import React, { useState, useEffect, useMemo, useRef } from 'react';
import moment from 'moment-timezone';
import { useDispatch, useSelector } from 'react-redux';
import { CloseIcon, CreditCardIcon, EuroIcon, ServicePriceIcon, WalletIcon } from '../../../assets/svg/iconos';
import { DropdownAll } from '../../../components/forms/DropdownAll';
import { startSaveVenta, startSaveVentaMultipago, startEnviarTicketVenta, startObtenerVenta, startObtenerVentasCita, startUpdateVenta } from '../../../actions/ventas';
import { getCita, refreshCita } from '../../../actions/citas';
import { DropdownDateWithoutCita } from '../../../components/forms/DropdownDateWithoutCita';
import { DropdownTimeWithoutCita } from '../../../components/forms/DropdownTimeWithoutCita';
import { setProfesionales } from '../../../actions/profesionales';
import { fetchConToken } from '../../../helpers/fetch';
import { DropdownClientes } from '../../../components/forms/DropdownClientes';
import { activeUsuario, unactiveUsuario } from '../../../actions/usuarios';
import { startLoadingProductos } from '../../../actions/productos';
import { openModalBottom } from '../../../actions/ui';
import Swal from 'sweetalert2';
import { DropdownMultipleServicios } from '../../../components/forms/DropdownMultipleServicios';
import { DropdownSucursales } from '../../../components/forms/DropdownSucursales';
import { MultiSelectionVariantes } from '../../../components/forms/MultiSelectionVariantes';
import { AvatarProfesional } from '../../sucursales/components/AvatarProfesional';
import { formatCurrency } from '../../../helpers/helpers';
import { calcularDescuentoServicioCentimos } from '../../../helpers/descuentoServicio';
import {
    serviciosCitaParaUI,
    variantesCitaParaUI,
    promocionesCitaParaUI,
    serviciosVentaParaUI,
    variantesVentaParaUI,
    promocionesVentaParaUI,
    productosVentaParaUI,
    resolverServicioEnCita,
} from '../../../helpers/citaVentaSnapshots';
import { detectarCambiosCitaVsVenta, nombreDesdeReferencia } from '../../../helpers/cambiosCitaVsVenta';
import { startCancelarCobro, startCobroDatafonoYEsperar } from '../../../actions/pos';
import {
    DECISION_DATAFONO,
    DECISION_MANUAL,
    DECISION_VIA_COBRO_INICIAL,
    ENRUTADO_DATAFONO,
    ENRUTADO_MANUAL,
    ENRUTADO_PENDIENTE_DECISION,
    ENRUTADO_SIN_RESOLVER,
    ESTADO_CANCELACION_SOLICITADA,
    METODO_PAGO_TARJETA,
    RESOLUCION_ERROR,
    datafonosActivos,
    datafonosDeSucursal,
    enrutadoCobro,
    mensajeEnrutadoSinResolver,
} from '../../../helpers/cobroDatafono';
import { useDatafonosSucursal } from '../../../hooks/useDatafonosSucursal';
import { ModalEsperaDatafono } from './ModalEsperaDatafono';

const METODOS_PAGO = [
    { _id: "Pago en efectivo", nombre: "Pago en efectivo" },
    { _id: "Pago Tarjeta", nombre: "Pago Tarjeta" },
    { _id: "Monedero", nombre: "Monedero" },
];

const normalizarMetodoPagoParaSelect = (rawMetodoPago) => {
    const raw = String(rawMetodoPago || '');
    if (!raw) return null;
    if (raw.includes('Pago en sucursal App')) return null;
    if (raw === 'Monedero' || raw === 'Monedero App' || raw === 'Monedero Admin') return 'Monedero';
    if (raw === 'Pago Tarjeta' || raw === 'Pago Tarjeta App') return 'Pago Tarjeta';
    if (raw === 'Pago en efectivo') return 'Pago en efectivo';
    return null;
};

const metodoPagoStateDesdeRaw = (rawMetodoPago) => {
    const id = normalizarMetodoPagoParaSelect(rawMetodoPago);
    return id ? [{ _id: id, nombre: id }] : [];
};

export const ModalVentas = ({
    history,
    citaActive: citaActiveProp,
    activeModalVentas,
    setActiveModalVentas,
    setActiveModalReserva,
    isOpen,
    onClose,
    setDataModal,
    setModalTwoButtonsOpened,
    setCitaActive,
    usuarioActive: usuarioActiveProp,
    ventaModoCitaCompleta = false,
    setVentaModoCitaCompleta,
}) => {
    const dispatch = useDispatch();
    const { uid, empresa } = useSelector(state => state.auth);
    const { colores } = useSelector(state => state.ui);
    const { servicios } = useSelector(state => state.servicios);
    const { sucursales } = useSelector(state => state.sucursales);
    const { promociones } = useSelector(state => state.promociones);
    const { variantes } = useSelector(state => state.variantes);
    const { profesionales } = useSelector(state => state.profesionales);
    const { usuarios, active: usuarioActivo } = useSelector(state => state.usuarios);
    const { active: citaActivaRedux } = useSelector(state => state.citas);
    const { productos } = useSelector(state => state.productos);

    const mismaCitaId = citaActiveProp?._id && citaActivaRedux?._id && String(citaActiveProp._id) === String(citaActivaRedux._id);
    const citaActive = mismaCitaId ? citaActivaRedux : citaActiveProp;
    const mismoUsuarioId = usuarioActiveProp?._id && usuarioActivo?._id && String(usuarioActiveProp._id) === String(usuarioActivo._id);
    const usuarioActive = mismoUsuarioId ? usuarioActivo : usuarioActiveProp;
	
    const [selectedServices, setSelectedServices] = useState([]);
    const [selectedVariantes, setSelectedVariantes] = useState([]);
    const [selectedPromociones, setSelectedPromociones] = useState([]);
	const [selectedProfesional, setSelectedProfesional] = useState([]);
	const [selectedSucursal, setSelectedSucursal] = useState([]);
    const [metodoPago, setMetodoPago] = useState([]);
    // EX-515: reparto del importe entre los métodos seleccionados (en modo multipago)
    const [repartoPagos, setRepartoPagos] = useState({});
	const [ventaExistente, setVentaExistente] = useState(null);
    const [clienteData, setClienteData] = useState({
        nombre: '',
        apellidos: '',
		saldoMonedero: 0
    });

    const [total, setTotal] = useState(0);

    const [serviciosSeleccionadosParaPago, setServiciosSeleccionadosParaPago] = useState([]);
    const [servicioPagoSeleccionado, setServicioPagoSeleccionado] = useState(null);

    const [selectUsuario, setSelectUsuario] = useState({
        selected: null,
        visible: true,
        active: false,
    });

    const [selectedProducts, setSelectedProducts] = useState([]);
    const [productQuantities, setProductQuantities] = useState({});

    // Añadir estado para el botón
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [ventaCompletada, setVentaCompletada] = useState(false);
    const [citaIdParaTicket, setCitaIdParaTicket] = useState(null);

    // EX-595: cobro en curso en el datáfono ({ estado, importe, pagoId }) y datáfono elegido
    // cuando la sucursal tiene más de uno. `desenlaceCobroDatafono` mantiene el modal de espera
    // abierto en los finales sin reintento, donde volver al formulario invitaría a cobrar dos veces.
    const [estadoCobroDatafono, setEstadoCobroDatafono] = useState(null);
    const [desenlaceCobroDatafono, setDesenlaceCobroDatafono] = useState(null);
    const [datafonoSeleccionado, setDatafonoSeleccionado] = useState(null);
    // EX-619: si este cobro con tarjeta va por el terminal o se anota a mano.
    // EX-622: arranca en "Por datáfono", que es el cobro común; "Anotar a mano" se elige.
    const [viaCobro, setViaCobro] = useState(DECISION_VIA_COBRO_INICIAL);
    const [enviandoTicket, setEnviandoTicket] = useState(false);
    const [ticketEnviado, setTicketEnviado] = useState(false);

    // EX-611: la configuración con la que se decide el enrutado se lee al abrir el modal, del
    // endpoint autenticado del POS. Ver `useDatafonosSucursal`.
    const {
        resolucion: resolucionDatafonos,
        sucursales: sucursalesConDatafonos,
        reintentar: reintentarDatafonos,
    } = useDatafonosSucursal(activeModalVentas);

    const getCitaRequestedForRef = useRef(null);
    const lastInitFromClienteUsuarioIdRef = useRef(null);
    // EX-515: la preselección automática de Monedero corre una vez por apertura del modal
    const monederoPreseleccionadoRef = useRef(false);
    // Cuando hay un único método seleccionado y el usuario no ha tocado el importe del reparto,
    // mantenemos ese importe sincronizado con el total (variantes/productos añadidos después
    // de la auto-selección no quedan fuera del importe asignado a Monedero/Tarjeta/Efectivo).
    const repartoEditadoManualmenteRef = useRef(false);
    // EX-517: mapa metodoNormalizado -> metodoRawOriginal por ventaId, usado para detectar
    // si la fila proviene del flujo "Pago en sucursal App" (que sigue siendo editable
    // como antes) frente al resto de ventas existentes (que pasan a solo lectura).
    const metodosOriginalesPorVentaRef = useRef({});
    // EX-517: loader inicial mientras se carga el desglose de ventas existentes; evita el
    // flash de valores intermedios al reabrir el modal sobre una cita con ventas registradas.
    const [cargandoVentaExistente, setCargandoVentaExistente] = useState(false);

    const metodoPagoAEnviar = metodoPago?.[0]?._id || null;

    const handleTotalChange = (e) => {
        const value = e.target.value;
        
        // Permitir números negativos, positivos y un único punto decimal
        if (/^-?\d*\.?\d*$/.test(value)) {
            // Si es un punto decimal y ya hay uno, no hacer nada
            if (value.includes('.') && value.split('.').length > 2) return;
            
            // Si hay decimales, limitar a 2 decimales
            if (value.includes('.')) {
                const [integer, decimal] = value.split('.');
                if (decimal && decimal.length > 2) return;
            }
            
            setTotal(value);
        }
    };

	useEffect(() => {
		if (!activeModalVentas) {
			lastInitFromClienteUsuarioIdRef.current = null;
			setServicioPagoSeleccionado(null);
			setVentaExistente(null);
			setSelectedServices([]);
			setSelectedVariantes([]);
			setSelectedPromociones([]);
			setSelectedProfesional([]);
			setSelectedSucursal([]);
			setMetodoPago([]);
			setRepartoPagos({});
			setSelectedProducts([]);
			setProductQuantities({});
			setTotal(0);
			setClienteData({ nombre: '', apellidos: '', saldoMonedero: 0 });
			metodosOriginalesPorVentaRef.current = {};
			setCargandoVentaExistente(false);
			// EX-622: la vía de cobro y el terminal elegidos no pasan al cobro siguiente.
			setViaCobro(DECISION_VIA_COBRO_INICIAL);
			setDatafonoSeleccionado(null);
		}
	}, [activeModalVentas]);

	useEffect(() => {
		if (!activeModalVentas) return;
		let isCurrent = true;

		if (!citaActive && usuarioActive && usuarioActive._id) {
			if (lastInitFromClienteUsuarioIdRef.current === usuarioActive._id) {
				return () => { isCurrent = false; };
			}
			lastInitFromClienteUsuarioIdRef.current = usuarioActive._id;
			setVentaExistente(null);
			setTotal(0);
			setClienteData({
				nombre: usuarioActive.nombre || '',
				apellidos: usuarioActive.apellidos || '',
				saldoMonedero: usuarioActive.saldoMonedero || 0
			});
			dispatch(activeUsuario(usuarioActive._id, usuarioActive));
			setSelectUsuario({
				_id: usuarioActive._id,
				selected: usuarioActive,
				visible: true,
				active: false
			});
			setSelectedServices([]);
			setSelectedVariantes([]);
			setSelectedPromociones([]);
			setSelectedProfesional([]);
			setSelectedSucursal([]);
			setMetodoPago([]);
			setSelectedProducts([]);
			setFechaCalendar(moment());
			setTimeCalendar(moment());
		} else if (citaActive) {
			const isMultiservicio = (citaActive.servicios?.length ?? 0) > 1;
			const servicioActualObj = citaActive.servicioActual;
			const servicioActualPagado = servicioActualObj?.pagada === true;
			const metodoPagoStr = String(citaActive.metodoPago || '');
			const esMonederoMasSucursalPendiente = !citaActive.pagada && metodoPagoStr.includes('Monedero App') && metodoPagoStr.includes('Pago en sucursal');

			let ventaIdACargar = null;
			if (isMultiservicio) {
				if (servicioActualPagado) {
					const vDetalle = servicioActualObj?.venta;
					ventaIdACargar = (vDetalle && typeof vDetalle === 'object' ? vDetalle._id : vDetalle) || null;
				}

			} else {
				if (esMonederoMasSucursalPendiente && citaActive.ventaPendienteSucursal?._id) {
					ventaIdACargar = citaActive.ventaPendienteSucursal._id;
				} else if (!esMonederoMasSucursalPendiente) {
					const vGlobal = citaActive.venta;
					ventaIdACargar = (vGlobal && typeof vGlobal === 'object' ? vGlobal._id : vGlobal) || null;
				}
			}
			const necesitaGetCita = !ventaIdACargar && citaActive._id && empresa && getCitaRequestedForRef.current !== citaActive._id
				&& (esMonederoMasSucursalPendiente || (String(citaActive.metodoPago || '').includes('Monedero App') && String(citaActive.metodoPago || '').includes('Pago en sucursal') && !citaActive.ventaPendienteSucursal));
			if (necesitaGetCita) {
				getCitaRequestedForRef.current = citaActive._id;
				dispatch(getCita(citaActive._id, empresa));
			}
			if (ventaIdACargar) {
				if ((!citaActive.variantes || citaActive.variantes.length === 0) && citaActive._id && empresa && getCitaRequestedForRef.current !== citaActive._id) {
					getCitaRequestedForRef.current = citaActive._id;
					dispatch(getCita(citaActive._id, empresa));
				}
				setClienteData({
					nombre: citaActive.usuario?.nombre || '',
					apellidos: citaActive.usuario?.apellidos || '',
					saldoMonedero: citaActive.usuario?.saldoMonedero || 0
				});
				if (citaActive.usuario?.nombre != null || citaActive.usuario?.apellidos != null || citaActive.usuario?._id) {
					setSelectUsuario({ _id: citaActive.usuario._id, selected: citaActive.usuario, visible: true, active: false });
				}
				if (citaActive.importe != null) setTotal(Number(citaActive.importe));
				const profResuelto = citaActive.profesional && (typeof citaActive.profesional === 'object' && citaActive.profesional !== null && (citaActive.profesional.nombre != null || citaActive.profesional._id))
					? citaActive.profesional
					: (citaActive.profesional && (profesionales || []).find(p => String(p._id || p) === String(citaActive.profesional)));
				setSelectedProfesional(profResuelto ? [profResuelto] : []);
				const sucResuelto = citaActive.sucursal && (typeof citaActive.sucursal === 'object' && citaActive.sucursal !== null && (citaActive.sucursal.nombre != null || citaActive.sucursal._id))
					? citaActive.sucursal
					: (citaActive.sucursal && (sucursales || []).find(s => String(s._id || s) === String(citaActive.sucursal)));
				setSelectedSucursal(sucResuelto ? [sucResuelto] : []);
				const serviciosResueltosPrefill = serviciosCitaParaUI(citaActive, servicios);
				if (serviciosResueltosPrefill.length > 0) {
					const unoOMulti = isMultiservicio && servicioActualObj
						? (() => {
							const idAct = servicioActualObj.servicio?._id || servicioActualObj.servicio;
							const enc = serviciosResueltosPrefill.find(sv => String(sv._id || sv) === String(idAct));
							return enc ? [enc] : [serviciosResueltosPrefill[0]];
						})()
						: serviciosResueltosPrefill.slice(0, 1);
					setSelectedServices(unoOMulti.length ? unoOMulti : serviciosResueltosPrefill);
				}
				const servicioIdStrPrefill = serviciosResueltosPrefill[0] ? String(serviciosResueltosPrefill[0]._id || serviciosResueltosPrefill[0]) : '';
				const variantesPrefill = variantesCitaParaUI(citaActive, variantes, servicioIdStrPrefill || undefined);
				setSelectedVariantes(variantesPrefill);
				const fechaPrefill = servicioActualObj?.fechaInicio ? moment(servicioActualObj.fechaInicio) : moment(citaActive.fecha);
				setFechaCalendar(fechaPrefill);
				setTimeCalendar(fechaPrefill);
				if (isMultiservicio && servicioActualObj && serviciosResueltosPrefill[0]) {
					const idxPrefill = (citaActive.servicios || []).findIndex(sd => String(sd?.servicio?._id || sd?.servicio) === String(serviciosResueltosPrefill[0]._id || serviciosResueltosPrefill[0]));
					setServicioPagoSeleccionado({
						servicio: serviciosResueltosPrefill[0],
						servicioDetalle: servicioActualObj,
						idx: idxPrefill >= 0 ? idxPrefill : 0
					});
				}
				// EX-517: si existen ventas en la cita, cargarlas todas y reconstruir el reparto
				// en modo solo lectura. La primera (mas antigua) actua como `ventaExistente`
				// para los datos compartidos; el resto se usan para construir las filas del desglose.
				setCargandoVentaExistente(true);
				const fetchVenta = async () => {
					try {
						const respCitaVentas = await dispatch(startObtenerVentasCita(citaActive._id));
						if (!isCurrent) return;

						let ventasCita = (respCitaVentas?.ok && Array.isArray(respCitaVentas.ventas))
							? [...respCitaVentas.ventas].sort((a, b) => {
								const fa = a?.fechaVenta ? new Date(a.fechaVenta).getTime() : 0;
								const fb = b?.fechaVenta ? new Date(b.fechaVenta).getTime() : 0;
								return fa - fb;
							})
							: [];

						// Si el modal se abrió desde un slot concreto de una cita multiservicio
						// pagada por servicios separados, restringir a la venta de ese slot para
						// no mezclar datos (importe, servicio) con las demás ventas de la cita.
						if (isMultiservicio && servicioActualPagado && ventaIdACargar && ventasCita.length > 1) {
							const ventaPropia = ventasCita.find(v => String(v?._id) === String(ventaIdACargar));
							if (ventaPropia) ventasCita = [ventaPropia];
						}

						if (ventasCita.length === 0) {
							metodosOriginalesPorVentaRef.current = {};
							return;
						}

						const data = { ok: true, venta: ventasCita[0] };
						setVentaExistente(data.venta);
						setSelectUsuario({
							_id: usuarioActivo._id,
							selected: usuarioActivo,
							visible: true,
							active: false
						});

						// EX-517: reconstruir el desglose en modo lectura a partir de TODAS las
						// ventas de la cita. Varias ventas con el mismo método de pago (p.ej.
						// cita multiservicio pagada con un único método mediante "Pagar cita
						// completa") se agrupan en una sola fila — repartoPagos se indexa por
						// metodoId, así que filas duplicadas leerían el mismo valor y la suma
						// se descuadraría.
						const filasReparto = [];
						const repartoNuevo = {};
						const metodosOrigenPorVenta = {};
						let totalReconstruido = 0;
						ventasCita.forEach(v => {
							const idNorm = normalizarMetodoPagoParaSelect(v?.metodoPago);
							if (!idNorm) return;
							const importeVenta = Number(v?.importe) || 0;
							totalReconstruido += importeVenta;
							if (!filasReparto.some(f => f._id === idNorm)) {
								filasReparto.push({ _id: idNorm, nombre: idNorm, ventaId: v._id });
							}
							repartoNuevo[idNorm] = (repartoNuevo[idNorm] || 0) + importeVenta;
							metodosOrigenPorVenta[v._id] = String(v?.metodoPago || '');
						});

						metodosOriginalesPorVentaRef.current = metodosOrigenPorVenta;

						setMetodoPago(filasReparto);
						setRepartoPagos(repartoNuevo);

						// Cargar datos del cliente
						setClienteData({
							nombre: data.venta.usuario?.nombre || '',
							apellidos: data.venta.usuario?.apellidos || '',
							saldoMonedero: data.venta.usuario?.saldoMonedero || 0
						});
						// Cargar datos de la venta: si es multiservicio mostrar un solo servicio (el de la franja si hay servicioActual, si no el primero)
						const ventaServicios = serviciosVentaParaUI(data.venta, servicios);
						const ventaVariantes = variantesVentaParaUI(data.venta, variantes);
						let servicioAMostrar = ventaServicios;
						const servicioActual = citaActive.servicioActual;
						if (ventaServicios.length > 1) {
							if (servicioActual) {
								const idServicioActual = servicioActual.servicio?._id || servicioActual.servicio;
								const encontrado = ventaServicios.find(itemServicio => String(itemServicio._id || itemServicio) === String(idServicioActual))
									|| serviciosCitaParaUI(citaActive, servicios).find(itemServicio => String(itemServicio._id || itemServicio) === String(idServicioActual));
								servicioAMostrar = encontrado ? [encontrado] : [ventaServicios[0]];
							} else {
								servicioAMostrar = [ventaServicios[0]];
							}
						}
						setSelectedServices(servicioAMostrar);
						const servicioIdStr = servicioAMostrar[0] ? String(servicioAMostrar[0]._id || servicioAMostrar[0]) : '';
						const resolverVariantes = (lista) => (lista || []).map(v => {
							if (v && typeof v === 'object' && (v.nombre || v.precio != null)) return v;
							const id = v && (v._id || v);
							return id ? (variantes || []).find(vr => String(vr._id || vr) === String(id)) : null;
						}).filter(Boolean);
						let variantesAUsar = resolverVariantes(ventaVariantes);
						if (variantesAUsar.length > 0 && servicioIdStr && ventaServicios.length > 1) {
							// Variantes de la venta pueden ser de varios servicios: quedarnos con las del servicio que estamos mostrando
							const variantesDelServicio = (variantes || []).filter(itemVarianteCatalogo =>
								(itemVarianteCatalogo.servicios || []).some(idServicioEnVariante =>
									String(idServicioEnVariante?._id || idServicioEnVariante) === servicioIdStr
								)
							);
							variantesAUsar = variantesAUsar.filter(itemVarianteSeleccionada =>
								variantesDelServicio.some(varianteCatalogo =>
									String(varianteCatalogo._id || varianteCatalogo) === String(itemVarianteSeleccionada._id || itemVarianteSeleccionada)
								)
							);
						}
						const hayVariantesCitaFallback = variantesCitaParaUI(citaActive, variantes, servicioIdStr).length > 0;
						const usoFallbackVariantes = variantesAUsar.length === 0 && servicioIdStr && hayVariantesCitaFallback;
						if (usoFallbackVariantes) {
							variantesAUsar = variantesCitaParaUI(citaActive, variantes, servicioIdStr);
						}
						setSelectedVariantes(variantesAUsar);
						const metodoPagoCita = String(citaActive.metodoPago || '');
						const esCitaMonederoMasSucursalPendiente = citaActive && !citaActive.pagada && metodoPagoCita.includes('Monedero App') && metodoPagoCita.includes('Pago en sucursal');
						const esVentaMonedero = String(data.venta.metodoPago || '') === 'Monedero App';
						const pendienteCita = citaActive.ventaPendienteSucursal?.importe != null
							? Number(citaActive.ventaPendienteSucursal.importe)
							: (citaActive.importe != null && data.venta.importe != null ? Number(citaActive.importe) - Number(data.venta.importe) : null);
						const usarPendiente = esCitaMonederoMasSucursalPendiente && esVentaMonedero && pendienteCita != null && !Number.isNaN(pendienteCita);
						// EX-518: si la cita está parcialmente pagada (multipago tras anular una venta),
						// el total debe ser cita.importe (no la suma de las activas) para que el desglose
						// se cuadre cuando el usuario añada nuevos métodos para cubrir el pendiente.
						const esCompletarPago = citaActive && citaActive.pagada === false && !esCitaMonederoMasSucursalPendiente;
						if (usarPendiente) {
							setTotal(pendienteCita);
						} else if (esCompletarPago && citaActive?.importe != null) {
							setTotal(parseFloat(Number(citaActive.importe).toFixed(2)));
						} else if (totalReconstruido > 0) {
							// EX-516: el total mostrado debe coincidir con la suma de las ventas existentes
							setTotal(parseFloat(totalReconstruido.toFixed(2)));
						} else if (isMultiservicio && servicioAMostrar[0]) {
							let precioRecalc = parseInt(servicioAMostrar[0].precio || 0, 10) || 0;
							(variantesAUsar || []).forEach(v => { precioRecalc += parseInt(v.valor || 0, 10) || 0; });
							const promosParaRecalcVenta = promocionesVentaParaUI(data.venta, promociones);
							promosParaRecalcVenta.forEach(pr => {
								if (pr && pr.porcentaje) precioRecalc -= precioRecalc * (Number(pr.porcentaje) / 100);
								else if (pr && pr.cifra) precioRecalc -= Number(pr.cifra) || 0;
							});
							setTotal(Math.max(0, precioRecalc / 100));
						} else {
							setTotal(data.venta.importe);
						}
						setSelectedPromociones(promocionesVentaParaUI(data.venta, promociones));
						const citaProf = citaActive?.servicioActual?.profesional ?? citaActive?.profesional;
						const citaSuc = citaActive?.sucursal;
						const ventaProf = data.venta.profesional;
						const ventaSuc = data.venta.sucursal;
						const profFromCita = citaProf && (typeof citaProf === 'object' && citaProf !== null && (citaProf.nombre != null || citaProf._id))
							? citaProf
							: (citaProf && (profesionales || []).find(p => String(p._id || p) === String(citaProf)));
						const profFromVenta = ventaProf && (typeof ventaProf === 'object' && ventaProf !== null && (ventaProf.nombre != null || ventaProf._id))
							? ventaProf
							: (ventaProf && (profesionales || []).find(p => String(p._id || p) === String(ventaProf)));
						const sucFromCita = citaSuc && (typeof citaSuc === 'object' && citaSuc !== null && (citaSuc.nombre != null || citaSuc._id))
							? citaSuc
							: (citaSuc && (sucursales || []).find(s => String(s._id || s) === String(citaSuc)));
						const sucFromVenta = ventaSuc && (typeof ventaSuc === 'object' && ventaSuc !== null && (ventaSuc.nombre != null || ventaSuc._id))
							? ventaSuc
							: (ventaSuc && (sucursales || []).find(s => String(s._id || s) === String(ventaSuc)));
						// Mostrar el profesional y la sucursal reales de la venta; si la venta no los tiene, caer a los de la cita.
						setSelectedProfesional(profFromVenta ? [profFromVenta] : (profFromCita ? [profFromCita] : []));
						setSelectedSucursal(sucFromVenta ? [sucFromVenta] : (sucFromCita ? [sucFromCita] : []));
						setSelectedProducts(productosVentaParaUI(data.venta, productos));
						const fechaVenta = servicioActual?.fechaInicio ? moment(servicioActual.fechaInicio) : moment(data.venta.fechaCita);
						setFechaCalendar(fechaVenta);
						setTimeCalendar(fechaVenta);
						if (isMultiservicio && servicioActual && servicioAMostrar[0]) {
							const idxDetalle = (citaActive.servicios || []).findIndex(sd => {
								const sdId = sd?.servicio?._id || sd?.servicio;
								return String(sdId) === String(servicioAMostrar[0]._id || servicioAMostrar[0]);
							});
							setServicioPagoSeleccionado({
								servicio: servicioAMostrar[0],
								servicioDetalle: servicioActual,
								idx: idxDetalle >= 0 ? idxDetalle : 0
							});
						}
					} catch (error) {
						console.error('Error al cargar la venta:', error);
					} finally {
						if (isCurrent) {
							setCargandoVentaExistente(false);
						}
					}
				};
				fetchVenta();
			} else {
				setVentaExistente(null);
				
				const servicioActual = citaActive.servicioActual;
				
				if (servicioActual) {
					const servicioId = servicioActual.servicio?._id || servicioActual.servicio;
					let servicio = resolverServicioEnCita(citaActive, servicioId, servicios);
					if (!servicio && servicioActual.nombre) {
						servicio = {
							_id: servicioId,
							nombre: servicioActual.nombre,
							precio: servicioActual.precio,
							duracion: servicioActual.duracionOriginal,
							duracion1: servicioActual.duracion1,
						};
					}
					
					if (servicio) {
						let precioServicio = parseInt(servicio.precio || 0, 10);
						
						const servicioIdActual = servicio._id || servicio;
						const servicioIdActualStr = String(servicioIdActual);

						const variantesDelServicio = variantesCitaParaUI(citaActive, variantes, servicioIdActualStr);

						if (variantesDelServicio.length > 0) {
							const precioVariantes = variantesDelServicio.reduce((total, varianteCompleta) => {
								if (varianteCompleta && varianteCompleta.valor) {
									return total + (varianteCompleta.valor || 0);
								}
								return total;
							}, 0);
							precioServicio += precioVariantes;
						}
						
						const serviciosParaTotalesDetalle = serviciosCitaParaUI(citaActive, servicios);
						const promosConImporte = citaActive.promociones?.filter(p => p.importeAplicado > 0) || [];
						if (promosConImporte.length > 0 && serviciosParaTotalesDetalle.length > 0) {
							const precioTotalServicios = serviciosParaTotalesDetalle.reduce((total, s) => {
								return total + parseInt(s.precio || 0, 10);
							}, 0);

							if (precioTotalServicios > 0) {
								const precioServicioBase = parseInt(servicio.precio || 0, 10);
								const proporcionServicio = precioServicioBase / precioTotalServicios;

								promosConImporte.forEach(promo => {
									const descuentoServicio = calcularDescuentoServicioCentimos(
										promo.importeAplicado,
										{ esCifra: false, proporcion: proporcionServicio }
									);
									precioServicio -= descuentoServicio;
								});
							}
						} else if (promocionesCitaParaUI(citaActive, promociones).length > 0) {
							promocionesCitaParaUI(citaActive, promociones).forEach(p => {
								if (p) {
									if (p.porcentaje) {
										precioServicio -= precioServicio * (Number(p.porcentaje) / 100);
									} else if (p.cifra) {
										precioServicio -= Number(p.cifra) || 0;
									}
								}
							});
						}
						
						if (citaActive.productos && citaActive.productos.length > 0) {
							const precioProductos = citaActive.productos.reduce((total, producto) => {
								return total + parseInt(producto.precio || 0, 10);
							}, 0);
							
							if (serviciosParaTotalesDetalle.length > 0) {
								const precioTotalServicios = serviciosParaTotalesDetalle.reduce((total, s) => {
									return total + parseInt(s.precio || 0, 10);
								}, 0);
								
								if (precioTotalServicios > 0) {
									const precioServicioBase = parseInt(servicio.precio || 0, 10);
									const proporcionServicio = precioServicioBase / precioTotalServicios;
									precioServicio += precioProductos * proporcionServicio;
								}
							}
						}
						
						const precioFinal = precioServicio / 100;
						const esMonederoMasSucursalPendienteSinVenta = !citaActive.pagada && String(citaActive.metodoPago || '').includes('Monedero App') && String(citaActive.metodoPago || '').includes('Pago en sucursal');
						if (esMonederoMasSucursalPendienteSinVenta) {
							if (citaActive.ventaPendienteSucursal?.importe != null) {
								setTotal(Number(citaActive.ventaPendienteSucursal.importe));
							}
						} else {
							setTotal(precioFinal);
						}

						const profesionalId = servicioActual.profesional?._id || servicioActual.profesional;
						const profesional = (profesionales || []).find(p => {
							const pId = p._id || p;
							return String(pId) === String(profesionalId);
						});
						
						setClienteData({
							nombre: citaActive.usuario?.nombre || '',
							apellidos: citaActive.usuario?.apellidos || '',
							saldoMonedero: citaActive.usuario?.saldoMonedero || 0
						});
						
						if (citaActive.usuario && citaActive.usuario._id) {
							if (String(usuarioActivo?._id) !== String(citaActive.usuario._id)) {
								dispatch(activeUsuario(citaActive.usuario._id, citaActive.usuario));
							}
							setSelectUsuario({
								selected: citaActive.usuario,
								visible: true,
								active: false
							});
						}
						
						setSelectedServices([servicio]);
						setSelectedVariantes(variantesDelServicio);
						setSelectedPromociones(promocionesCitaParaUI(citaActive, promociones));
						setSelectedProfesional(profesional ? [profesional] : []);
						setSelectedSucursal(citaActive.sucursal ? [citaActive.sucursal] : []);
						setMetodoPago([]);
						setSelectedProducts([]);
					setFechaCalendar(servicioActual.fechaInicio ? moment(servicioActual.fechaInicio) : moment(citaActive.fecha));
					setTimeCalendar(servicioActual.fechaInicio ? moment(servicioActual.fechaInicio) : moment(citaActive.fecha));
					const idxDetalle = citaActive.servicios
						? citaActive.servicios.findIndex(sd => {
							const sdId = sd?.servicio?._id || sd?.servicio;
							return String(sdId) === String(servicioId);
						})
						: -1;
					setServicioPagoSeleccionado({
						servicio,
						servicioDetalle: servicioActual,
						idx: idxDetalle >= 0 ? idxDetalle : 0
					});
				}
                } else {
                    if (citaActive.servicios && citaActive.servicios.length > 1) {
                        setServiciosSeleccionadosParaPago([]);
                        // Sin pre-selección: no mostrar ningún profesional hasta que el usuario elija servicios
                        setServicioPagoSeleccionado(null);
                    } else {
                        setServiciosSeleccionadosParaPago([]);
                        setServicioPagoSeleccionado(null);
                    }

				const usuarioId = citaActive.usuario && (citaActive.usuario._id || citaActive.usuario);
				const usuarioConNombre = citaActive.usuario && typeof citaActive.usuario === 'object' && (citaActive.usuario.nombre != null || citaActive.usuario.apellidos != null);
				let usuarioResuelto = usuarioConNombre ? citaActive.usuario : (usuarios && usuarioId ? usuarios.find(u => String(u._id || u) === String(usuarioId)) : null) || (usuarioActive && (usuarioActive._id || usuarioActive.nombre) ? usuarioActive : null) || citaActive.usuario;
				if (usuarioResuelto) {
					setClienteData({
						nombre: usuarioResuelto.nombre || '',
						apellidos: usuarioResuelto.apellidos || '',
						saldoMonedero: usuarioResuelto.saldoMonedero ?? 0
					});
					if (String(usuarioActivo?._id) !== String(usuarioResuelto._id || usuarioId)) {
						dispatch(activeUsuario(usuarioResuelto._id || usuarioId, usuarioResuelto));
					}
					setSelectUsuario({
						selected: usuarioResuelto,
						visible: true,
						active: false
					});
				} else {
					setClienteData({ nombre: '', apellidos: '', saldoMonedero: 0 });
					dispatch(unactiveUsuario());
					setSelectUsuario({ selected: null, visible: true, active: false });
				}
				const serviciosResueltos = serviciosCitaParaUI(citaActive, servicios);
				const unSoloServicio = citaActive.servicios?.length === 1
					? serviciosResueltos.slice(0, 1)
					: (citaActive.servicios?.length > 1 ? serviciosResueltos.slice(0, 1) : serviciosResueltos);
				setSelectedServices(unSoloServicio);
				if (citaActive.servicios?.length > 1 && (!citaActive.variantes || citaActive.variantes.length === 0) && citaActive._id && empresa && getCitaRequestedForRef.current !== citaActive._id) {
					const primerDetalle = citaActive.servicios?.[0] || { servicio: citaActive.servicios?.[0], profesional: citaActive.profesional, fechaInicio: citaActive.fecha };
					getCitaRequestedForRef.current = citaActive._id;
					dispatch(getCita(citaActive._id, empresa, { servicioActual: primerDetalle }));
				}
				const servicioInicialParaVariantes = unSoloServicio?.[0] || serviciosResueltos[0];
				const servicioIdStr = servicioInicialParaVariantes ? String(servicioInicialParaVariantes._id || servicioInicialParaVariantes) : '';
				const variantesDesdeCita = variantesCitaParaUI(citaActive, variantes, servicioIdStr || undefined);
				const rawVariantes = citaActive.variantes && citaActive.variantes.length > 0
					? [citaActive.variantes].flat()
					: (citaActive.servicios && citaActive.servicios[0]?.variantes ? [citaActive.servicios[0].variantes].flat() : []);
				const rawVariantesIds = rawVariantes.map(idOrObj => idOrObj && String(idOrObj._id || idOrObj)).filter(Boolean);
				const variantesDelServicioCatalogo = servicioIdStr && variantes?.length
					? variantes.filter(v => (v.servicios || []).some(sId => String(sId?._id || sId) === servicioIdStr))
					: [];
				const variantesParaSeleccionar = variantesDesdeCita.length > 0
					? variantesDesdeCita
					: variantesDelServicioCatalogo.filter(v => rawVariantesIds.includes(String(v._id || v)));
				setSelectedVariantes(variantesParaSeleccionar);
				setSelectedPromociones(promocionesCitaParaUI(citaActive, promociones));
				// Con varios servicios en la cita no pre-rellenar profesional; el usuario elige servicios y se muestran sus profesionales
				const profesionalInicial = citaActive.servicios?.length > 1 ? [] : (citaActive.profesional ? [citaActive.profesional].flat().map(p => typeof p === 'object' && p !== null && (p.nombre || p._id) ? p : (profesionales || []).find(pr => String(pr._id || pr) === String(p && (p._id || p)))).filter(Boolean) : []);
				setSelectedProfesional(profesionalInicial);
				setSelectedSucursal(citaActive.sucursal ? [citaActive.sucursal].flat() : []);
				setMetodoPago(metodoPagoStateDesdeRaw(citaActive.metodoPago));
				const rawProductos = citaActive.productos ? [citaActive.productos].flat() : [];
				const productosResueltos = rawProductos.map(idOrObj => {
					const id = idOrObj && (idOrObj._id || idOrObj);
					if (!id) return null;
					const found = productos.find(p => String(p._id || p) === String(id));
					return found || idOrObj;
				}).filter(Boolean);
				setSelectedProducts(productosResueltos);
				setFechaCalendar(moment(citaActive.fecha));
				setTimeCalendar(moment(citaActive.fecha));		
				}
			}
		} else if (usuarioActivo && usuarioActive) {
			setVentaExistente(null);
			setTotal(0);
			setSelectUsuario({
				_id: usuarioActivo._id,
				selected: usuarioActivo,
				visible: true,
				active: false
			});
			setClienteData({
				nombre: usuarioActivo.nombre || '',
				apellidos: usuarioActivo.apellidos || '',
				saldoMonedero: usuarioActivo.saldoMonedero || 0
			});
			setSelectedServices([]);
			setSelectedVariantes([]);
			setSelectedPromociones([]);
			setSelectedProfesional([]);
			setSelectedSucursal([]);
			setMetodoPago([]);
			setSelectedProducts([]);
			setFechaCalendar(moment());
			setTimeCalendar(moment());
		}
		return () => { isCurrent = false; };
	}, [citaActive, usuarioActive, variantes, usuarios, promociones, productos, profesionales, servicios, activeModalVentas]);

	useEffect(() => {
		if (ventaModoCitaCompleta && citaActive && activeModalVentas) {
			const metodoPagoStrEff = String(citaActive.metodoPago || '');
			const esMonederoMasSucursalPorMetodo = metodoPagoStrEff.includes('Monedero App') && metodoPagoStrEff.includes('Pago en sucursal');
			const pendienteSucursal = citaActive.ventaPendienteSucursal?.importe != null
				? Number(citaActive.ventaPendienteSucursal.importe)
				: (citaActive.importe != null && citaActive.venta?.importe != null ? Number(citaActive.importe) - Number(citaActive.venta.importe) : 0);
			const importeCita = (esMonederoMasSucursalPorMetodo && !citaActive.pagada)
				? pendienteSucursal
				: (citaActive.importe != null ? Number(citaActive.importe) : 0);
			setTotal(importeCita);
			const inicioCita = citaActive.servicios?.[0]?.fechaInicio
				? moment(citaActive.servicios[0].fechaInicio)
				: moment(citaActive.fecha);
			setFechaCalendar(inicioCita);
			setTimeCalendar(inicioCita);
			const serviciosResueltos = serviciosCitaParaUI(citaActive, servicios);
			if (serviciosResueltos.length > 0) {
				setSelectedServices(serviciosResueltos);
			}
			const variantesResueltas = variantesCitaParaUI(citaActive, variantes);
			setSelectedVariantes(variantesResueltas);
			if (citaActive.usuario) {
				setClienteData({
					nombre: citaActive.usuario.nombre || '',
					apellidos: citaActive.usuario.apellidos || '',
					saldoMonedero: citaActive.usuario.saldoMonedero ?? 0
				});
				setSelectUsuario({ _id: citaActive.usuario._id, selected: citaActive.usuario, visible: true, active: false });
			}
			const idsProfVistos = new Set();
			const listaProfesionalesCompleta = (citaActive.servicios || []).reduce((acc, sd) => {
				const profId = sd?.profesional?._id || sd?.profesional || citaActive.profesional?._id || citaActive.profesional;
				if (profId && !idsProfVistos.has(String(profId))) {
					idsProfVistos.add(String(profId));
					const prof = (typeof sd?.profesional === 'object' && sd.profesional?.nombre != null)
						? sd.profesional
						: (profesionales || []).find(p => String(p._id || p) === String(profId));
					if (prof) acc.push(prof);
				}
				return acc;
			}, []);
			if (listaProfesionalesCompleta.length > 0) {
				setSelectedProfesional(listaProfesionalesCompleta);
			} else {
				const profResuelto = citaActive.profesional && (typeof citaActive.profesional === 'object' && citaActive.profesional?.nombre != null)
					? citaActive.profesional
					: (profesionales || []).find(p => String(p._id || p) === String(citaActive.profesional));
				setSelectedProfesional(profResuelto ? [profResuelto] : []);
			}
			const sucResuelto = citaActive.sucursal && (typeof citaActive.sucursal === 'object' && citaActive.sucursal?.nombre != null)
				? citaActive.sucursal
				: (sucursales || []).find(s => String(s._id || s) === String(citaActive.sucursal));
			setSelectedSucursal(sucResuelto ? [sucResuelto] : []);
		}
	}, [ventaModoCitaCompleta, citaActive, activeModalVentas, servicios, variantes, profesionales, sucursales]);

	useEffect(() => {
		if (!citaActive || !citaActive.servicios || citaActive.servicios.length <= 1 || ventaModoCitaCompleta) return;
		// Profesionales: si hay varios servicios seleccionados, mostrar todos los profesionales de esos servicios (Ana + Juan, etc.)
		if (selectedServices && selectedServices.length > 0 && citaActive.servicios?.length > 0) {
			const idsVistos = new Set();
			const listaProfesionales = [];
			selectedServices.forEach(svc => {
				const servicioIdStr = String(svc._id || svc);
				const detalle = (citaActive.servicios || []).find(sd =>
					String(sd?.servicio?._id || sd?.servicio) === servicioIdStr
				);
				const profesionalId = detalle?.profesional?._id || detalle?.profesional || citaActive.profesional?._id;
				if (profesionalId && !idsVistos.has(String(profesionalId))) {
					idsVistos.add(String(profesionalId));
					const profesional = (profesionales || []).find(p => String(p._id || p) === String(profesionalId));
					if (profesional) listaProfesionales.push(profesional);
				}
			});
			setSelectedProfesional(listaProfesionales);
		} else {
			setSelectedProfesional([]);
		}
		if (!servicioPagoSeleccionado) return;
		const sel = servicioPagoSeleccionado;
		const servicio = sel.servicio;
		const servicioDetalle = sel.servicioDetalle;
		const servicioIdActual = servicio._id || servicio;
		const servicioIdActualStr = String(servicioIdActual);
		const variantesPorSnapshot = variantesCitaParaUI(citaActive, variantes, servicioIdActualStr);
		const fuenteVariantesMulti = (citaActive.variantes && citaActive.variantes.length > 0)
			? citaActive.variantes
			: (servicioDetalle?.variantes && servicioDetalle.variantes.length > 0 ? servicioDetalle.variantes : []);
		if (fuenteVariantesMulti.length === 0 && variantesPorSnapshot.length === 0 && citaActive._id && empresa && getCitaRequestedForRef.current !== citaActive._id) {
			getCitaRequestedForRef.current = citaActive._id;
			dispatch(getCita(citaActive._id, empresa));
		}
		const variantesDelServicioRaw = fuenteVariantesMulti.length > 0
			? fuenteVariantesMulti.filter(varianteIdOrObj => {
				const varianteId = varianteIdOrObj._id || varianteIdOrObj;
				const varianteCompleta = variantes.find(v => {
					const vId = v._id || v;
					return String(vId) === String(varianteId);
				});
				if (!varianteCompleta) return false;
				const serviciosVariante = varianteCompleta.servicios || [];
				return serviciosVariante.some(servicioIdVariante => {
					const sIdVariante = servicioIdVariante._id || servicioIdVariante;
					const sIdVarianteStr = String(sIdVariante);
					return sIdVarianteStr === servicioIdActualStr || servicioIdVariante === servicioIdActual;
				});
			})
			: [];
		const variantesDelServicioLegacy = variantesDelServicioRaw
			.map(varianteIdOrObj => variantes.find(v => String(v._id || v) === String(varianteIdOrObj._id || varianteIdOrObj)))
			.filter(Boolean);
		const variantesDelServicio = variantesPorSnapshot.length > 0 ? variantesPorSnapshot : variantesDelServicioLegacy;
		const fechaInicio = servicioDetalle?.fechaInicio ? moment(servicioDetalle.fechaInicio) : moment(citaActive.fecha);
		if (citaActive.servicios.length <= 1) {
			setSelectedServices([servicio]);
		}
		// Con varios servicios no sobrescribir variantes: mantener las de todos los servicios seleccionados
		if (!selectedServices || selectedServices.length <= 1) {
			setSelectedVariantes(variantesDelServicio);
		}
		setSelectedSucursal(citaActive.sucursal ? [citaActive.sucursal] : []);
		setFechaCalendar(fechaInicio);
		setTimeCalendar(fechaInicio);
	// eslint-disable-next-line react-hooks/exhaustive-deps -- profesionales omitido a propósito para no sobrescribir la selección al cambiar de profesional
	}, [servicioPagoSeleccionado, citaActive, variantes, ventaModoCitaCompleta, empresa, selectedServices, profesionales]);

	useEffect(() => {
		if (!citaActive || citaActive.servicios?.length <= 1 || !servicioPagoSeleccionado?.servicioDetalle || ventaModoCitaCompleta) return;
		const detalle = servicioPagoSeleccionado.servicioDetalle;
		if (!detalle.pagada) return;
		const ventaId = (detalle.venta && typeof detalle.venta === 'object' ? detalle.venta._id : detalle.venta) || null;
		if (!ventaId) return;
		const sel = servicioPagoSeleccionado;
		setSelectedServices(sel.servicio ? [sel.servicio] : []);
		if (detalle.fechaInicio) {
			const fechaSlot = moment(detalle.fechaInicio);
			setFechaCalendar(fechaSlot);
			setTimeCalendar(fechaSlot);
		}
		const profSlot = detalle.profesional && (typeof detalle.profesional === 'object' && detalle.profesional !== null)
			? detalle.profesional
			: (detalle.profesional && (profesionales || []).find(p => String(p._id || p) === String(detalle.profesional)));
		setSelectedProfesional(profSlot ? [profSlot] : []);
		const sucSlot = citaActive.sucursal && (typeof citaActive.sucursal === 'object' && citaActive.sucursal !== null)
			? citaActive.sucursal
			: (citaActive.sucursal && (sucursales || []).find(s => String(s._id || s) === String(citaActive.sucursal)));
		setSelectedSucursal(sucSlot ? [sucSlot] : []);
		let isCurrent = true;
		const loadVentaForServicio = async () => {
			try {
				const data = await dispatch(startObtenerVenta(ventaId));
				if (!isCurrent || !data.ok || !data.venta) return;
				const venta = data.venta;
				setVentaExistente(venta);
				setTotal(venta.importe != null ? Number(venta.importe) : 0);
				setSelectedPromociones(promocionesVentaParaUI(venta, promociones));
				setSelectedProducts(productosVentaParaUI(venta, productos));
				// EX-517: enlazar la fila con el ventaId real para preservar el origen (p.ej. "Pago en sucursal App")
				const idNorm = normalizarMetodoPagoParaSelect(venta.metodoPago);
				if (idNorm) {
					setMetodoPago([{ _id: idNorm, nombre: idNorm, ventaId: venta._id }]);
					setRepartoPagos({ [idNorm]: Number(venta.importe) || 0 });
					metodosOriginalesPorVentaRef.current = { [venta._id]: String(venta.metodoPago || '') };
				} else {
					setMetodoPago(metodoPagoStateDesdeRaw(venta.metodoPago));
				}
			} catch (e) {
				console.error('Error al cargar venta del servicio', e);
			}
		};
		loadVentaForServicio();
		return () => { isCurrent = false; };
	}, [servicioPagoSeleccionado, citaActive, ventaModoCitaCompleta, promociones, productos, profesionales, sucursales]);

	const servicioActual = selectedServices?.[0] || servicioPagoSeleccionado?.servicio
		|| (citaActive && serviciosCitaParaUI(citaActive, servicios).length === 1 ? serviciosCitaParaUI(citaActive, servicios)[0] : null)
		|| (citaActive?.servicios?.length === 1 ? citaActive.servicios[0] : null);
	const variantesDelServicioActual = useMemo(() => {
		if (!servicioActual || !variantes?.length) return [];
		const servicioIdStr = String(servicioActual._id || servicioActual);
		return variantes.filter(v => {
			const serviciosVariante = v.servicios || [];
			return serviciosVariante.some(sId => String(sId?._id || sId) === servicioIdStr);
		});
	}, [servicioActual, variantes]);

	// Variantes que pertenecen a alguno de los servicios seleccionados (para no quitar variantes al tener varios servicios)
	const variantesDeServiciosSeleccionados = useMemo(() => {
		if (!selectedServices?.length || !variantes?.length) return [];
		const idsServicios = new Set(selectedServices.map(s => String(s._id || s)));
		return variantes.filter(v => {
			const serviciosVariante = v.servicios || [];
			return serviciosVariante.some(sId => idsServicios.has(String(sId?._id || sId)));
		});
	}, [selectedServices, variantes]);

	useEffect(() => {
		if (variantesDeServiciosSeleccionados.length === 0) return;
		setSelectedVariantes(prev => {
			if (prev.length === 0) return prev;
			return prev.filter(p => variantesDeServiciosSeleccionados.some(vd => String(vd._id || vd) === String(p._id || p)));
		});
	}, [variantesDeServiciosSeleccionados]);

	useEffect(() => {
		recalcularTotal();
	}, [servicioPagoSeleccionado, selectedServices, selectedVariantes, selectedPromociones, selectedProducts, productQuantities, citaActive?.servicioActual, citaActive?.importe, ventaExistente, citaActive, ventaModoCitaCompleta]);

    
    const calcularPrecioServicio = (servicio, servicioDetalle, cita, variantesOverride) => {
        let precioServicio = parseInt(servicio.precio || 0, 10);
        
        const servicioIdActual = servicio._id || servicio;
        const servicioIdActualStr = String(servicioIdActual);
        const variantesDesdeSnapshot = variantesCitaParaUI(cita, variantes, servicioIdActualStr);
        
        let variantesDelServicio = [];
        if (variantesOverride != null && Array.isArray(variantesOverride)) {
            variantesDelServicio = variantesOverride.filter(varianteIdOrObj => {
                const varianteId = varianteIdOrObj._id || varianteIdOrObj;
                const varianteCompleta = variantes.find(v => {
                    const vId = v._id || v;
                    return String(vId) === String(varianteId);
                });
                if (!varianteCompleta) return false;
                const serviciosVariante = varianteCompleta.servicios || [];
                return serviciosVariante.some(servicioIdVariante => {
                    const sIdVariante = servicioIdVariante._id || servicioIdVariante;
                    const sIdVarianteStr = String(sIdVariante);
                    return sIdVarianteStr === servicioIdActualStr || servicioIdVariante === servicioIdActual;
                });
            });
        } else if (variantesDesdeSnapshot.length > 0) {
            variantesDelServicio = variantesDesdeSnapshot;
        } else if (cita?.variantes && cita.variantes.length > 0) {
            const fuenteVariantes = cita.variantes;
            variantesDelServicio = fuenteVariantes.filter(varianteIdOrObj => {
                const varianteId = varianteIdOrObj._id || varianteIdOrObj;
                const varianteCompleta = variantes.find(v => {
                    const vId = v._id || v;
                    return String(vId) === String(varianteId);
                });
                if (!varianteCompleta) return false;
                const serviciosVariante = varianteCompleta.servicios || [];
                return serviciosVariante.some(servicioIdVariante => {
                    const sIdVariante = servicioIdVariante._id || servicioIdVariante;
                    const sIdVarianteStr = String(sIdVariante);
                    return sIdVarianteStr === servicioIdActualStr || servicioIdVariante === servicioIdActual;
                });
            });
        }
        
        if (variantesDelServicio.length > 0) {
            const precioVariantes = variantesDelServicio.reduce((total, varianteIdOrObj) => {
                if (varianteIdOrObj.valor != null) {
                    return total + (varianteIdOrObj.valor || 0);
                }
                const varianteId = varianteIdOrObj._id || varianteIdOrObj;
                const varianteCompleta = variantes.find(v => {
                    const vId = v._id || v;
                    return String(vId) === String(varianteId);
                });
                if (varianteCompleta && varianteCompleta.valor) {
                    return total + (varianteCompleta.valor || 0);
                }
                return total;
            }, 0);
            precioServicio += precioVariantes;
        }
        
        const serviciosParaTotalesCalc = serviciosCitaParaUI(cita, servicios);
        const esServicioOriginalDeCita = (cita?.servicios || []).some(sd =>
            String(sd?.servicio?._id || sd?.servicio) === servicioIdActualStr
        );
        const promosConImporteCalc = esServicioOriginalDeCita
            ? (cita?.promociones?.filter(p => p.importeAplicado > 0) || [])
            : [];
        if (promosConImporteCalc.length > 0 && serviciosParaTotalesCalc.length > 0) {
            const precioTotalServicios = serviciosParaTotalesCalc.reduce((total, s) => {
                return total + parseInt(s.precio || 0, 10);
            }, 0);

            if (precioTotalServicios > 0) {
                const precioServicioBase = parseInt(servicio.precio || 0, 10);
                const proporcionServicio = precioServicioBase / precioTotalServicios;

                promosConImporteCalc.forEach(promo => {
                    const descuentoServicio = calcularDescuentoServicioCentimos(
                        promo.importeAplicado,
                        { esCifra: false, proporcion: proporcionServicio }
                    );
                    precioServicio -= descuentoServicio;
                });
            }
        }
        
        if (cita?.productos && cita.productos.length > 0) {
            const precioProductos = cita.productos.reduce((total, producto) => {
                return total + parseInt(producto.precio || 0, 10);
            }, 0);
            
            if (serviciosParaTotalesCalc.length > 0) {
                const precioTotalServicios = serviciosParaTotalesCalc.reduce((total, s) => {
                    return total + parseInt(s.precio || 0, 10);
                }, 0);
                
                if (precioTotalServicios > 0) {
                    const precioServicioBase = parseInt(servicio.precio || 0, 10);
                    const proporcionServicio = precioServicioBase / precioTotalServicios;
                    precioServicio += precioProductos * proporcionServicio;
                }
            }
        }
        
        return precioServicio / 100;
    };
    
    const recalcularTotal = () => {
        if (ventaModoCitaCompleta && citaActive) {
            const metodoPagoStrRecalc = String(citaActive.metodoPago || '');
            const esMonederoMasSucursalRecalc = metodoPagoStrRecalc.includes('Monedero App') && metodoPagoStrRecalc.includes('Pago en sucursal');
            if (esMonederoMasSucursalRecalc && !citaActive.pagada && citaActive.ventaPendienteSucursal?.importe != null) {
                let pendingTotal = Number(citaActive.ventaPendienteSucursal.importe);
                selectedProducts.forEach(product => {
                    const qty = productQuantities[product._id] ?? 1;
                    pendingTotal += (parseFloat(product.precio || 0) / 100) * qty;
                });
                setTotal(parseFloat(pendingTotal.toFixed(2)));
                return;
            }
            if (esMonederoMasSucursalRecalc && citaActive.pagada && citaActive.importe != null) {
                setTotal(Number(citaActive.importe));
                return;
            }
        }
        if (!ventaModoCitaCompleta && citaActive && !ventaExistente && !citaActive.pagada && citaActive.ventaPendienteSucursal?.importe != null) {
            const metodoStr = String(citaActive.metodoPago || '');
            if (metodoStr.includes('Monedero App') && metodoStr.includes('Pago en sucursal')) {
                let pendingTotal = Number(citaActive.ventaPendienteSucursal.importe);
                selectedProducts.forEach(product => {
                    const qty = productQuantities[product._id] ?? 1;
                    pendingTotal += (parseFloat(product.precio || 0) / 100) * qty;
                });
                setTotal(parseFloat(pendingTotal.toFixed(2)));
                return;
            }
        }
        let nuevoTotal = 0;
        let promosYaAplicadasEnServicio = false;

        const cantidadServiciosCita = Math.max(
            citaActive?.servicios?.length || 0,
            serviciosCitaParaUI(citaActive, servicios).length
        );

        if (citaActive && cantidadServiciosCita > 1 && selectedServices && selectedServices.length > 0) {
            selectedServices.forEach((servicio) => {
                const servicioIdStr = String(servicio._id || servicio);
                const servicioConPrecio = (servicios?.length && (servicio.precio == null || servicio.precio === undefined))
                    ? (servicios.find(s => String(s._id || s) === servicioIdStr) || servicio)
                    : servicio;
                const servicioDetalle = (citaActive.servicios || []).find(sd =>
                    String(sd?.servicio?._id || sd?.servicio) === servicioIdStr
                );
                const variantesParaServicio = (selectedVariantes || []).filter(v => {
                    const varianteCompleta = variantes?.find(vr => String(vr._id || vr) === String(v._id || v));
                    return varianteCompleta && (varianteCompleta.servicios || []).some(sId => String(sId?._id || sId) === servicioIdStr);
                });
                nuevoTotal += calcularPrecioServicio(servicioConPrecio, servicioDetalle || null, citaActive, variantesParaServicio);
            });
        } else if (citaActive && cantidadServiciosCita === 1) {
            const serviciosACalcular = (selectedServices && selectedServices.length > 0)
                ? selectedServices
                : (serviciosCitaParaUI(citaActive, servicios).length > 0 ? serviciosCitaParaUI(citaActive, servicios) : citaActive.servicios);
            serviciosACalcular.forEach((sel, idx) => {
                let servicio = sel;
                const servicioId = servicio && (servicio._id || servicio);
                if (servicioId && (servicio.precio == null || servicio.precio === 0)) {
                    const servicioCompleto = servicios?.find(s => String(s._id || s) === String(servicioId));
                    if (servicioCompleto) servicio = servicioCompleto;
                }
                if (idx === 0) {
                    const servicioDetalle = citaActive.servicios && citaActive.servicios.length > 0
                        ? citaActive.servicios[0]
                        : null;
                    const parcial = calcularPrecioServicio(servicio, servicioDetalle, citaActive, selectedVariantes);
                    nuevoTotal += parcial;
                    if (parcial === 0 && serviciosACalcular.length === 1 && citaActive.importe != null) {
                        nuevoTotal = Number(citaActive.importe);
                    }
                } else {
                    const id = servicio && (servicio._id || servicio);
                    const precio = servicio?.precio != null
                        ? Number(servicio.precio)
                        : (id && servicios?.length ? (servicios.find(s => String(s._id || s) === String(id))?.precio ?? 0) : 0);
                    nuevoTotal += precio / 100;
                }
            });
        } else {
            const precioServicios = selectedServices.reduce((sum, service) => {
                const id = service && (service._id || service);
                const precio = service?.precio != null ? Number(service.precio) : (id && servicios?.length ? (servicios.find(s => String(s._id || s) === String(id))?.precio ?? 0) : 0);
                return sum + precio;
            }, 0);
            nuevoTotal = precioServicios / 100;
            selectedVariantes.forEach(variante => {
                const varianteCompleta = variantes.find(v => String(v._id || v) === String(variante._id || variante));
                if (varianteCompleta) {
                    nuevoTotal += (varianteCompleta.valor || 0) / 100;
                }
            });
        }

        const promosConImporteAplicado = citaActive?.promociones?.filter(p => p.importeAplicado > 0) || [];
        if (promosConImporteAplicado.length > 0 && (citaActive && (cantidadServiciosCita >= 1))) {
            promosYaAplicadasEnServicio = true;
        }

        if (!promosYaAplicadasEnServicio) {
            selectedPromociones.forEach(promo => {
                if (promo.porcentaje) {
                    nuevoTotal -= nuevoTotal * (Number(promo.porcentaje) / 100);
                } else if (promo.cifra) {
                    nuevoTotal -= (Number(promo.cifra) / 100);
                }
            });
        }

        selectedProducts.forEach(product => {
            const qty = productQuantities[product._id] ?? 1;
            nuevoTotal += (parseFloat(product.precio || 0) / 100) * qty;
        });

        const nuevoTotalRedondeado = parseFloat(nuevoTotal.toFixed(2));
        const ventaRef = ventaExistente || (citaActive?.venta && typeof citaActive.venta === 'object' ? citaActive.venta : null);
        const importeVenta = ventaRef?.importe != null ? Number(ventaRef.importe) : null;
        setTotal(Math.max(0, (importeVenta != null && importeVenta > nuevoTotalRedondeado && selectedProducts?.length === 0) ? importeVenta : nuevoTotalRedondeado));
    };

    const handleSubmit = async () => {
        if (isSubmitting) return;

        try {
            if (!selectUsuario.selected) {
                dispatch(openModalBottom({
                    text: ['El usuario es requerido'],
                    timeOut: 3
                }));
                return;
            }

            if (citaActive && citaActive.servicios && citaActive.servicios.length > 1) {
                if (!selectedServices || selectedServices.length === 0) {
                    dispatch(openModalBottom({
                        text: ['Selecciona al menos un servicio a pagar desde las cards'],
                        timeOut: 3
                    }));
                    return;
                }
            } else if (!citaActive) {
                const tieneServicios = selectedServices && selectedServices.length > 0;
                const tieneProductos = selectedProducts && selectedProducts.length > 0;
                if (!tieneServicios && !tieneProductos) {
                    dispatch(openModalBottom({
                        text: ['Selecciona al menos un servicio o un producto'],
                        timeOut: 3
                    }));
                    return;
                }
                if (!selectedSucursal || selectedSucursal.length === 0) {
                    dispatch(openModalBottom({
                        text: ['La sucursal es requerida'],
                        timeOut: 3
                    }));
                    return;
                }

                if (!selectedProfesional || selectedProfesional.length === 0) {
                    dispatch(openModalBottom({
                        text: ['El profesional es requerido'],
                        timeOut: 3
                    }));
                    return;
                }
            }

            // EX-517: el desglose en modo edicion es solo lectura. Por defensa, si se llegase
            // aqui con `esVistaSoloLectura`, abortar sin guardar nada.
            if (esVistaSoloLectura) {
                return;
            }

            // EX-611: sin saber si la sucursal cobra en el terminal no se elige camino. Anotar la
            // venta a mano aquí sería dar por cobrada una tarjeta que nadie ha pasado, y es
            // justo el fallo silencioso que este corte existe para evitar. Va antes de construir
            // `ventaData` para cubrir por igual las cuatro ramas de cobro de más abajo.
            if (enrutadoSinResolver) {
                setDataModal({
                    title: 'El pago no se ha anotado',
                    text: [mensajeEnrutadoSinResolver(resolucionDatafonos)],
                    buttonText: 'Aceptar',
                    button2Text: 'Cancelar'
                });
                setModalTwoButtonsOpened(true);
                return;
            }

            // EX-619: con terminal disponible, el camino lo decide el operario (EX-622: arranca en
            // "Por datáfono"). Sin decisión no se lanza nada, y por datáfono con varios activos
            // tampoco hasta saber cuál.
            // Va en el mismo sitio que el corte de EX-611 y por el mismo motivo: cubre por igual
            // las cuatro ramas de cobro de más abajo.
            if (decisionCobroPendiente) {
                dispatch(openModalBottom({
                    text: ['Elige si el cobro con tarjeta va por el datáfono o se anota a mano'],
                    timeOut: 3
                }));
                return;
            }
            if (faltaElegirDatafono) {
                dispatch(openModalBottom({
                    text: ['Elige en qué datáfono se cobra'],
                    timeOut: 3
                }));
                return;
            }

            // EX-518: en modo completar pago, hay que añadir al menos un método nuevo (sin ventaId)
            // con importe > 0 para crear la(s) venta(s) que cubran el pendiente.
            if (esModoCompletarPago && !tieneFilasNuevas) {
                dispatch(openModalBottom({
                    text: ['Añade al menos un método de pago nuevo para completar el cobro'],
                    timeOut: 3
                }));
                return;
            }

            // EX-515: cuando hay >=1 metodo el reparto manda (creacion o flujo sucursal pendiente)
            const usaReparto = metodoPago.length >= 1;
            if (!usaReparto && !metodoPagoAEnviar) {
                dispatch(openModalBottom({
                    text: ['El método de pago es requerido'],
                    timeOut: 3
                }));
                return;
            }

            if (usaReparto) {
                if (!sumaCuadra) {
                    dispatch(openModalBottom({
                        text: ['La suma del reparto debe coincidir con el importe total'],
                        timeOut: 3
                    }));
                    return;
                }
                if (monederoExcedeSaldo) {
                    dispatch(openModalBottom({
                        text: ['El importe asignado al monedero supera el saldo disponible'],
                        timeOut: 3
                    }));
                    return;
                }
            } else if (!ventaExistente && metodoPago?.[0]?._id === 'Monedero' && usuarioActivo?.saldoMonedero < total) {
                dispatch(openModalBottom({
                    text: ['No hay suficiente saldo para generar esta venta'],
                    timeOut: 3
                }));
                return;
            }

            // EX-526: avisar si la sucursal o el profesional de la venta difieren de los de la cita
            // (en multiservicio, el profesional se compara contra el slot que se está cobrando).
            const cambios = detectarCambiosCitaVsVenta({
                cita: citaActive,
                selectedSucursal,
                selectedProfesional,
                servicioPagoSeleccionado,
            });
            if (cambios.cambioSucursal || cambios.cambioProfesional) {
                const filas = [];
                if (cambios.cambioSucursal) {
                    const nombreCita = nombreDesdeReferencia(cambios.sucursalCita, sucursales);
                    const nombreVenta = nombreDesdeReferencia(cambios.sucursalVenta, sucursales);
                    filas.push(`<div><strong>Sucursal</strong><br/>Cita: ${nombreCita}<br/>Venta: ${nombreVenta}</div>`);
                }
                if (cambios.cambioProfesional) {
                    const nombreCita = nombreDesdeReferencia(cambios.profesionalCita, profesionales);
                    const nombreVenta = nombreDesdeReferencia(cambios.profesionalVenta, profesionales);
                    filas.push(`<div><strong>Profesional</strong><br/>Cita: ${nombreCita}<br/>Venta: ${nombreVenta}</div>`);
                }
                const { isConfirmed } = await Swal.fire({
                    title: 'Confirmar venta',
                    html: `<p>Los siguientes datos de la venta difieren de la cita:</p>${filas.join('<br/>')}<p>¿Confirmar venta con estos valores?</p>`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Confirmar',
                    cancelButtonText: 'Cancelar',
                });
                if (!isConfirmed) return;
            }

            setIsSubmitting(true);

            let ventaData;
            
            if (citaActive && citaActive.servicios && citaActive.servicios.length > 1 && selectedServices && selectedServices.length > 0) {
                let serviciosPagadosIndices = (citaActive.servicios || []).reduce((acc, sd, idx) => {
                    const sdServicioId = String(sd?.servicio?._id || sd?.servicio);
                    const selected = (selectedServices || []).some(s => String(s._id || s) === sdServicioId);
                    if (selected) acc.push(idx);
                    return acc;
                }, []);
                const servicioActual = citaActive.servicioActual;
                if (serviciosPagadosIndices.length === 0 && selectedServices.length === 1 && (citaActive.servicios?.length ?? 0) > 1 && servicioActual) {
                    const servicioAEnviar = selectedServices[0];
                    let idxSlot = servicioPagoSeleccionado?.idx ?? (citaActive.servicios?.findIndex(sd => String(sd?.servicio?._id || sd?.servicio) === String(servicioAEnviar._id || servicioAEnviar)));
                    if (idxSlot < 0) {
                        const idSlotActual = servicioActual?.servicio?._id || servicioActual?.servicio;
                        const fechaSlotActual = servicioActual?.fechaInicio ? String(servicioActual.fechaInicio) : null;
                        idxSlot = citaActive.servicios?.findIndex(sd => {
                            if (sd === servicioActual) return true;
                            const idSd = sd?.servicio?._id || sd?.servicio;
                            if (idSlotActual && idSd && String(idSd) === String(idSlotActual)) return true;
                            if (fechaSlotActual && sd?.fechaInicio && String(sd.fechaInicio) === fechaSlotActual) return true;
                            return false;
                        }) ?? -1;
                    }
                    if (idxSlot >= 0) serviciosPagadosIndices = [idxSlot];
                }
                if (ventaModoCitaCompleta && (citaActive.servicios?.length ?? 0) > 1) {
                    serviciosPagadosIndices = (citaActive.servicios || []).map((_, i) => i);
                }
                let importesPorServicioDetalle = [];
                if (citaActive.servicios && citaActive.servicios.length > 0) {
                    const len = citaActive.servicios.length;
                    importesPorServicioDetalle = Array(len).fill(0);
                    serviciosPagadosIndices.forEach((idx) => {
                        const sd = citaActive.servicios[idx];
                        const servicioId = sd?.servicio?._id || sd?.servicio;
                        const servicio = (selectedServices || []).find(referenciaServicio => String(referenciaServicio?._id || referenciaServicio) === String(servicioId))
                            || citaActive.servicios?.find(referenciaServicio => String(referenciaServicio?._id || referenciaServicio) === String(servicioId));
                        if (!servicio) return;
                        const variantesParaServicio = (selectedVariantes || []).filter(itemVarianteSeleccionada => {
                            const varianteEnCatalogo = variantes?.find(itemVarianteCatalogo =>
                                String(itemVarianteCatalogo._id || itemVarianteCatalogo) === String(itemVarianteSeleccionada._id || itemVarianteSeleccionada)
                            );
                            return (
                                varianteEnCatalogo &&
                                (varianteEnCatalogo.servicios || []).some(idServicioEnVariante =>
                                    String(idServicioEnVariante?._id || idServicioEnVariante) === String(servicioId)
                                )
                            );
                        });
                        const importeBlock = calcularPrecioServicio(servicio, sd, citaActive, variantesParaServicio);
                        importesPorServicioDetalle[idx] = parseFloat(Number(importeBlock).toFixed(2));
                    });
                    const sumImportes = importesPorServicioDetalle.reduce((a, b) => a + b, 0);
                    const totalNum = parseFloat(total);
                    if (sumImportes > 0 && Math.abs(sumImportes - totalNum) > 0.01) {
                        const factor = totalNum / sumImportes;
                        importesPorServicioDetalle = importesPorServicioDetalle.map(imp => parseFloat((imp * factor).toFixed(2)));
                    }
                    if (serviciosPagadosIndices.length === 1 && sumImportes === 0) {
                        importesPorServicioDetalle[serviciosPagadosIndices[0]] = parseFloat(total);
                    }
                    if (sumImportes === 0 && serviciosPagadosIndices.length > 1 && totalNum > 0) {
                        const sumPreciosSubdoc = serviciosPagadosIndices.reduce((acc, idx) => acc + (Number(citaActive.servicios?.[idx]?.precio) || 0), 0);
                        if (sumPreciosSubdoc > 0) {
                            serviciosPagadosIndices.forEach((idx) => {
                                const precioSubdoc = Number(citaActive.servicios?.[idx]?.precio) || 0;
                                importesPorServicioDetalle[idx] = parseFloat(((precioSubdoc / sumPreciosSubdoc) * totalNum).toFixed(2));
                            });
                        }
                    }
                }
                const primerDetalle = serviciosPagadosIndices.length > 0 && citaActive.servicios?.[serviciosPagadosIndices[0]];
                const profesionalId = selectedProfesional?.[0]?._id || primerDetalle?.profesional?._id || primerDetalle?.profesional || citaActive.profesional?._id || citaActive.profesional;
                const sucursalId = selectedSucursal?.[0]?._id || citaActive.sucursal?._id || citaActive.sucursal;
                const fechaCita = primerDetalle?.fechaInicio ? moment(primerDetalle.fechaInicio).toDate() : moment(citaActive.fecha).toDate();
                const serviciosParaVenta = (ventaModoCitaCompleta && citaActive.servicios?.length > 0)
                    ? citaActive.servicios.map(sd => {
                        const sid = sd?.servicio?._id ?? sd?.servicio;
                        return (citaActive.servicios || []).find(s => String(s?._id || s) === String(sid)) || (sid ? { _id: sid } : null);
                    }).filter(Boolean)
                    : selectedServices;
                ventaData = {
                    empresa,
                    usuario: selectUsuario.selected._id,
                    sucursal: sucursalId,
                    profesional: profesionalId,
                    fechaCita,
                    importe: parseFloat(total),
                    promociones: (selectedPromociones || []).map(p => p._id || p),
                    servicios: serviciosParaVenta,
                    variantes: (selectedVariantes || []).map(v => ({ variante: v._id || v })),
                    metodoPago: metodoPagoAEnviar,
                    productos: (selectedProducts || []).map(p => ({ producto: p._id || p, cantidad: productQuantities[p._id] ?? 1 })),
                    cita: citaActive._id,
                    serviciosPagadosIndices,
                    ...(importesPorServicioDetalle.length > 0 && { importesPorServicioDetalle })
                };
            } else if (citaActive?.servicioActual && citaActive.servicios && citaActive.servicios.length > 1) {
                const servicioActual = citaActive.servicioActual;
                const servicioAEnviar = selectedServices?.[0] || (servicioActual.servicio && citaActive.servicios?.find(s => s && String(s._id || s) === String(servicioActual.servicio?._id || servicioActual.servicio)));
                if (!servicioAEnviar) {
                    dispatch(openModalBottom({ text: ['Selecciona al menos un servicio a pagar'], timeOut: 3 }));
                    setIsSubmitting(false);
                    return;
                }
                const detalleParaSlot = servicioPagoSeleccionado?.servicioDetalle || servicioActual;
                const profesionalId = selectedProfesional?.[0]?._id || detalleParaSlot.profesional?._id || detalleParaSlot.profesional || servicioActual.profesional?._id || servicioActual.profesional;
                const sucursalId = selectedSucursal?.[0]?._id || citaActive?.sucursal?._id || citaActive?.sucursal;
                let serviciosPagadosIndices = [];
                const idxSlot = servicioPagoSeleccionado?.idx ?? (citaActive.servicios?.findIndex(sd => String(sd?.servicio?._id || sd?.servicio) === String(servicioAEnviar._id || servicioAEnviar)));
                if (idxSlot >= 0) {
                    serviciosPagadosIndices.push(idxSlot);
                } else {
                    const idSlotActual = servicioActual?.servicio?._id || servicioActual?.servicio;
                    const fechaSlotActual = servicioActual?.fechaInicio ? String(servicioActual.fechaInicio) : null;
                    const idxDetalleActual = citaActive.servicios?.findIndex(sd => {
                        if (sd === servicioActual) return true;
                        const idSd = sd?.servicio?._id || sd?.servicio;
                        if (idSlotActual && idSd && String(idSd) === String(idSlotActual)) return true;
                        if (fechaSlotActual && sd?.fechaInicio && String(sd.fechaInicio) === fechaSlotActual) return true;
                        return false;
                    });
                    if (idxDetalleActual >= 0) {
                        serviciosPagadosIndices.push(idxDetalleActual);
                    }
                }
                const fechaCitaSlot = (servicioPagoSeleccionado?.servicioDetalle?.fechaInicio || servicioActual?.fechaInicio) ? moment(servicioPagoSeleccionado?.servicioDetalle?.fechaInicio || servicioActual.fechaInicio).toDate() : moment(timeCalendar).toDate();
                ventaData = {
                    empresa,
                    usuario: selectUsuario.selected._id,
                    sucursal: sucursalId,
                    profesional: profesionalId,
                    fechaCita: fechaCitaSlot,
                    importe: parseFloat(total),
                    promociones: (selectedPromociones || []).map(p => p._id || p),
                    servicios: [servicioAEnviar],
                    variantes: (selectedVariantes || []).map(v => ({ variante: v._id || v })),
                    metodoPago: metodoPagoAEnviar,
                    productos: (selectedProducts || []).map(p => ({ producto: p._id || p, cantidad: productQuantities[p._id] ?? 1 })),
                    ...(citaActive && { cita: citaActive._id, serviciosPagadosIndices })
                };
            } else {
                const serviciosPagadosIndicesElse = citaActive?.servicios?.length > 0
                    ? citaActive.servicios.map((_, i) => i)
                    : [];
                ventaData = {
                empresa,
                usuario: selectUsuario.selected._id,
                sucursal: selectedSucursal[0]?._id,
                profesional: selectedProfesional[0]?._id,
                fechaCita: moment(timeCalendar).toDate(),
                importe: parseFloat(total),
                promociones: (selectedPromociones || []).map(p => p._id || p),
                servicios: selectedServices,
                variantes: (selectedVariantes || []).map(v => ({ variante: v._id || v })),
                metodoPago: metodoPagoAEnviar,
                productos: (selectedProducts || []).map(p => ({ producto: p._id || p, cantidad: productQuantities[p._id] ?? 1 })),
                ...(citaActive && {
                    cita: citaActive._id,
                    ...(serviciosPagadosIndicesElse.length > 0 && { serviciosPagadosIndices: serviciosPagadosIndicesElse })
                })
            };
            }

            // EX-595: con datáfono activo el admin no persiste nada aquí. El importe va al
            // terminal y las ventas las crea el backend cuando Paylands confirma el pago, así que
            // se espera al desenlace y se resuelve con el mismo contrato que `startSaveVenta`.
            const cobrarEnDatafono = (payloadVenta, tipoPayload, ventaId) => dispatch(startCobroDatafonoYEsperar(
                {
                    payloadVenta,
                    tipoPayload,
                    ventaId,
                    deviceId: datafonoParaCobro?.deviceId,
                    descripcion: `Cobro ${selectUsuario.selected?.nombre || ''}`.trim(),
                },
                { onEstado: setEstadoCobroDatafono }
            ));

            let response;
            if (esFlujoSucursalPendiente && ventaExistente) {
                // EX-517: en el flujo "Monedero App + Pago en sucursal App", el admin completa
                // el pago pendiente — comportamiento previo a EX-516: PUT sobre la venta existente.
                if (metodoPago.length === 1) {
                    ventaData.metodoPago = metodoPago[0]._id;
                    ventaData.importe = parseFloat(Number(repartoPagos[metodoPago[0]._id] ?? total).toFixed(2));
                }
                // EX-605: con datáfono activo el pendiente se cobra en el terminal y es el backend
                // quien completa la venta pendiente (`actualizacion`), sin crear ninguna nueva.
                //
                // Al terminal va el importe PENDIENTE, no el total del formulario. Los dos caminos
                // liquidan la cita de forma distinta: el manual reescribe la venta del monedero por
                // el total y devuelve al monedero lo ya consumido; el datáfono completa la venta de
                // "Pago en sucursal App" y deja el monedero gastado como está. Mandar el total aquí
                // cobraría de más al cliente justo por lo que ya pagó con su saldo.
                if (debeEnrutarADatafono) {
                    const ventaPendienteData = { ...ventaData, importe: importePendienteSucursal };
                    response = await cobrarEnDatafono(ventaPendienteData, 'actualizacion', ventaPendienteACobrar);
                } else {
                    response = await dispatch(startUpdateVenta(ventaExistente._id, ventaData));
                }
            } else if (esModoCompletarPago) {
                // EX-518: solo se envían las filas nuevas (sin ventaId) al endpoint multipago.
                // Las ventas existentes ya están persistidas y no se tocan; el backend recalcula
                // cita.pagada y cita.importe (combinarDatosTodasVentas excluye anulada=true).
                const pagosNuevos = metodoPago
                    .filter(m => !m.ventaId)
                    .map(m => ({
                        metodo: m._id,
                        importe: parseFloat(Number(repartoPagos[m._id] || 0).toFixed(2))
                    }))
                    .filter(p => p.importe > 0);
                const importeNuevo = pagosNuevos.reduce((acc, p) => acc + p.importe, 0);
                const { metodoPago: _ignorado, importe: _ignoradoImporte, ...restoVentaData } = ventaData;
                const ventaMultipagoData = {
                    ...restoVentaData,
                    importeTotal: parseFloat(importeNuevo.toFixed(2)),
                    pagos: pagosNuevos
                };
                if (debeEnrutarADatafono) {
                    response = await cobrarEnDatafono(ventaMultipagoData, 'multipago');
                } else {
                    const respMultipago = await dispatch(startSaveVentaMultipago(ventaMultipagoData));
                    response = respMultipago.ok
                        ? { ok: true, venta: respMultipago.ventas?.[0], cita: respMultipago.cita }
                        : { ok: false, msg: respMultipago.msg };
                }
            } else if (metodoPago.length > 1) {
                // EX-515: pago combinado con N métodos
                const pagosArray = metodoPago.map(metodo => ({
                    metodo: metodo._id,
                    importe: parseFloat(Number(repartoPagos[metodo._id] || 0).toFixed(2))
                }));
                const { metodoPago: _ignorado, importe: _ignoradoImporte, ...restoVentaData } = ventaData;
                const ventaMultipagoData = {
                    ...restoVentaData,
                    importeTotal: parseFloat(total),
                    pagos: pagosArray
                };
                if (debeEnrutarADatafono) {
                    response = await cobrarEnDatafono(ventaMultipagoData, 'multipago');
                } else {
                    const respMultipago = await dispatch(startSaveVentaMultipago(ventaMultipagoData));
                    response = respMultipago.ok
                        ? { ok: true, venta: respMultipago.ventas?.[0], cita: respMultipago.cita }
                        : { ok: false, msg: respMultipago.msg };
                }
            } else {
                // EX-515: 1 solo método (modo creación o multipago con N=1) usa el endpoint clásico
                if (esModoMultipago && metodoPago.length === 1) {
                    ventaData.metodoPago = metodoPago[0]._id;
                    ventaData.importe = parseFloat(Number(repartoPagos[metodoPago[0]._id] ?? total).toFixed(2));
                }
                response = debeEnrutarADatafono
                    ? await cobrarEnDatafono(ventaData, 'simple')
                    : await dispatch(startSaveVenta(ventaData));
            }

            // El modal de espera solo sobrevive a la respuesta en los desenlaces sin reintento
            // (tarjeta ya cobrada o cobro en curso): ahí no se vuelve al formulario.
            if (response?.permiteReintento !== false) {
                setEstadoCobroDatafono(null);
            }

			if (response.ok) {
				const pagadosIndices = ventaData.serviciosPagadosIndices || [];
				const citaDesdeBackend = response.cita;
				const serviciosActualizado = (citaDesdeBackend?.servicios && citaDesdeBackend.servicios.length > 0)
					? citaDesdeBackend.servicios
					: citaActive?.servicios?.map((sd, idx) => {
						if (pagadosIndices.includes(idx)) {
							return { ...sd, pagada: true, venta: response.venta?._id };
						}
						return sd;
					});
				const citaActualizada = {
					importe: parseFloat(total),
					promocion: selectedPromociones,
					productos: response.venta?.productos ?? selectedProducts,
					variantes: citaActive?.variantes || [],
					...(serviciosActualizado && { servicios: serviciosActualizado })
				};
				const profesionalObj = selectedProfesional?.[0] || response.cita?.profesional || citaActive?.profesional;
				const sucursalObj = selectedSucursal?.[0] || response.cita?.sucursal || citaActive?.sucursal;
				if (citaActive && response.cita) {
					const citaBackend = response.cita;
					const usuarioPopulado = (typeof citaBackend?.usuario === 'object' && citaBackend.usuario !== null)
						? citaBackend.usuario
						: (citaActive?.usuario ?? citaBackend?.usuario);
					const sucursalPoblada = (typeof citaBackend?.sucursal === 'object' && citaBackend.sucursal !== null)
						? citaBackend.sucursal
						: (citaActive?.sucursal ?? citaBackend?.sucursal);
					const citaParaDispatch = {
						...response.cita,
						...citaActualizada,
						...(usuarioPopulado != null && { usuario: usuarioPopulado }),
						...(sucursalPoblada != null && { sucursal: sucursalPoblada }),
						profesional: profesionalObj,
						sucursal: sucursalObj
					};
					const servicioActualActualizado = citaParaDispatch.servicioActual
						? { ...citaParaDispatch.servicioActual, profesional: profesionalObj, sucursal: sucursalObj }
						: citaParaDispatch.servicioActual;
				const serviciosActualizados = Array.isArray(citaParaDispatch.servicios)
					? citaParaDispatch.servicios.map(sd => ({ ...sd, sucursal: sucursalObj }))
					: citaParaDispatch.servicios;
				const primerNoPagado = Array.isArray(serviciosActualizados) && serviciosActualizados.length > 0
					? serviciosActualizados.find(sd => !sd.pagada) || serviciosActualizados[0]
					: null;
				const servicioDetalleParaRedux = primerNoPagado
					? { ...primerNoPagado, profesional: profesionalObj, sucursal: sucursalObj }
					: (servicioActualActualizado != null ? servicioActualActualizado : null);
				dispatch(refreshCita(citaActive._id, {
					...citaParaDispatch,
					...(servicioDetalleParaRedux != null && { servicioActual: servicioDetalleParaRedux }),
					...(serviciosActualizados != null && { servicios: serviciosActualizados })
				}));
			} else if (citaActive) {
				const payloadFallback = {
					...citaActive,
					...citaActualizada,
					profesional: profesionalObj,
					sucursal: sucursalObj
				};
				const serviciosFallback = Array.isArray(payloadFallback.servicios)
					? payloadFallback.servicios.map(sd => ({ ...sd, sucursal: sucursalObj }))
					: payloadFallback.servicios;
				const primerNoPagadoFallback = Array.isArray(serviciosFallback) && serviciosFallback.length > 0
					? serviciosFallback.find(sd => !sd.pagada) || serviciosFallback[0]
					: null;
				const servicioDetalleParaReduxFallback = primerNoPagadoFallback
					? { ...primerNoPagadoFallback, profesional: profesionalObj, sucursal: sucursalObj }
					: (payloadFallback.servicioActual ? { ...payloadFallback.servicioActual, profesional: profesionalObj, sucursal: sucursalObj } : null);
				dispatch(refreshCita(citaActive._id, {
					...payloadFallback,
					...(servicioDetalleParaReduxFallback != null && { servicioActual: servicioDetalleParaReduxFallback }),
					...(serviciosFallback != null && { servicios: serviciosFallback })
				}));
				}

				const citaRelacionadaId = response.cita?.citaRelacionada
					? (typeof response.cita.citaRelacionada === 'object' ? response.cita.citaRelacionada._id : response.cita.citaRelacionada)
					: null;
				if (citaRelacionadaId && empresa) {
					fetchConToken(`citas/cita/${citaRelacionadaId}`, { empresa }, 'POST')
						.then(r => r.json())
						.then(data => { if (data.cita?._id) dispatch(refreshCita(data.cita._id, data.cita)); })
						.catch(() => {});
				}

				const ventasEnDetalle = response.cita?.servicios?.filter(sd => sd?.venta).length ?? 0;
				setVentaExistente(ventasEnDetalle > 1 ? null : (response.venta || null));

				if (response.venta) {
					const venta = response.venta;
					const citaResp = response.cita;
					if (venta.importe != null) setTotal(Number(venta.importe));
					setSelectedPromociones(promocionesVentaParaUI(venta, promociones || []));
					setSelectedProducts(productosVentaParaUI(venta, productos || []));
					setMetodoPago(metodoPagoStateDesdeRaw(venta.metodoPago));
					const ventaServicios = serviciosVentaParaUI(venta, servicios || []);
					let serviciosAMostrar = ventaServicios;
					if (ventaServicios.length > 1 && citaResp?.servicioActual) {
						const idAct = citaResp.servicioActual.servicio?._id || citaResp.servicioActual.servicio;
						const enc = ventaServicios.find(s => String(s._id || s) === String(idAct));
						serviciosAMostrar = enc ? [enc] : [ventaServicios[0]];
					} else if (ventaServicios.length > 0) {
						serviciosAMostrar = [ventaServicios[0]];
					}
					setSelectedServices(serviciosAMostrar);
					let variantesVenta = variantesVentaParaUI(venta, variantes || []);
					const servicioIdStrVenta = serviciosAMostrar[0] ? String(serviciosAMostrar[0]._id || serviciosAMostrar[0]) : '';
					if (variantesVenta.length > 0 && servicioIdStrVenta && ventaServicios.length > 1) {
						const variantesDelServicio = (variantes || []).filter(v => (v.servicios || []).some(sId => String(sId?._id || sId) === servicioIdStrVenta));
						variantesVenta = variantesVenta.filter(v => variantesDelServicio.some(vd => String(vd._id || vd) === String(v._id || v)));
					}
					setSelectedVariantes(variantesVenta);
					const profParaForm = selectedProfesional?.[0] || venta.profesional || citaResp?.profesional || citaActive?.profesional;
					const profResueltoForm = profParaForm && (typeof profParaForm === 'object' && profParaForm !== null && (profParaForm.nombre != null || profParaForm._id))
						? profParaForm
						: (profParaForm && (profesionales || []).find(p => String(p._id || p) === String(profParaForm)));
					const sucParaForm = selectedSucursal?.[0] || venta.sucursal || citaResp?.sucursal || citaActive?.sucursal;
					const sucResueltoForm = sucParaForm && (typeof sucParaForm === 'object' && sucParaForm !== null && (sucParaForm.nombre != null || sucParaForm._id))
						? sucParaForm
						: (sucParaForm && (sucursales || []).find(s => String(s._id || s) === String(sucParaForm)));
					setSelectedProfesional(profResueltoForm ? [profResueltoForm] : []);
					setSelectedSucursal(sucResueltoForm ? [sucResueltoForm] : []);
					const fechaVentaResp = citaResp?.servicioActual?.fechaInicio
						? moment(citaResp.servicioActual.fechaInicio)
						: (venta.fechaCita ? moment(venta.fechaCita) : (citaResp?.fecha ? moment(citaResp.fecha) : null));
					if (fechaVentaResp) {
						setFechaCalendar(fechaVentaResp);
						setTimeCalendar(fechaVentaResp);
					}
					if (citaResp?.servicios?.length > 1 && serviciosAMostrar[0]) {
						const detalleActual = citaResp.servicioActual || citaResp.servicios?.find(sd => sd?.pagada && (sd?.venta?._id || sd?.venta) === (venta._id || venta));
						const detalleParaSlot = detalleActual || citaResp.servicios?.find(sd =>
							String(sd?.servicio?._id || sd?.servicio) === String(serviciosAMostrar[0]._id || serviciosAMostrar[0])
						);
						if (detalleParaSlot) {
							const idxDetalle = (citaResp.servicios || []).findIndex(sd =>
								String(sd?.servicio?._id || sd?.servicio) === String(serviciosAMostrar[0]._id || serviciosAMostrar[0])
							);
							setServicioPagoSeleccionado({
								servicio: serviciosAMostrar[0],
								servicioDetalle: detalleParaSlot,
								idx: idxDetalle >= 0 ? idxDetalle : 0
							});
						}
					}
				}

				const wasUpdate = !!ventaExistente;
				const datos = {
					text: [wasUpdate ? 'El pago se ha modificado correctamente' : 'El pago se ha registrado correctamente'],
					timeOut: 3
				};
				dispatch(openModalBottom(datos));
				setVentaCompletada(true);
				setCitaIdParaTicket(citaActive?._id || null);
            } else if (response.permiteReintento === false) {
                // EX-595: la tarjeta puede estar ya cobrada. El modal de espera se queda en su
                // estado final y el de venta se cierra desde ahí, para que nadie vuelva a cobrar
                // sobre el mismo formulario sin haberlo revisado antes.
                setDesenlaceCobroDatafono({ estado: response.estado, detalleError: response.detalleError });
            } else {
                const errorMsg = response.error?.message || response.error || 'No se pudo procesar el pago. Por favor, inténtelo de nuevo.';
                setDataModal({
                    title: 'Error',
                    text: [typeof errorMsg === 'string' ? errorMsg : 'No se pudo procesar el pago. Por favor, inténtelo de nuevo.'],
                    buttonText: 'Aceptar',
                    button2Text: 'Cancelar'
                });
                setModalTwoButtonsOpened(true);
            }
        } catch (error) {
            console.error('Error al procesar el pago:', error);
            setDataModal({
                title: 'Error',
                text: ['Ha ocurrido un error al procesar el pago'],
                buttonText: 'Aceptar',
                button2Text: 'Cancelar'
            });
            setModalTwoButtonsOpened(true);
        } finally {
            setIsSubmitting(false);
        }
    };
	const handleSucursalSelected = (sucursalOrArray) => {
		const next = Array.isArray(sucursalOrArray) ? sucursalOrArray : (sucursalOrArray ? [sucursalOrArray] : []);
		setSelectedSucursal(next);
	};
	const handleServicesChanged = (services) => {
        const esUnSoloSlotMultiservicio = citaActive?.servicios?.length > 1 && selectedServices.length === 1;
        const esCitaUnServicio = citaActive?.servicios?.length === 1;
        if ((esCitaUnServicio || esUnSoloSlotMultiservicio) && selectedServices.length === 1 && services.length === 2) {
            const prevId = String(selectedServices[0]?._id || selectedServices[0]);
            const ids = (services || []).map(s => String(s._id || s));
            if (ids.includes(prevId)) {
                const nuevo = services.find(s => String(s._id || s) !== prevId);
                if (nuevo) {
                    if (citaActive.servicios?.length > 1) {
                        const idx = (citaActive.servicios || []).findIndex(sd =>
                            String(sd?.servicio?._id || sd?.servicio) === String(nuevo._id || nuevo)
                        );
                        const detalle = idx >= 0 ? citaActive.servicios[idx] : null;
                        setServicioPagoSeleccionado(detalle ? { servicio: nuevo, servicioDetalle: detalle, idx } : null);
                    } else {
                        setServicioPagoSeleccionado(null);
                    }
                    setSelectedServices([nuevo]);
                    setVentaExistente(null);
                    setSelectedPromociones([]);
                    setSelectedProducts([]);
                    return;
                }
            }
        }
        setSelectedServices(services);
        if (citaActive?.servicios?.length > 1 && services?.length === 1) {
            const servicio = services[0];
            const servicioId = servicio._id || servicio;
            const idx = (citaActive.servicios || []).findIndex(sd =>
                String(sd?.servicio?._id || sd?.servicio) === String(servicioId)
            );
            const servicioDetalle = idx >= 0 ? citaActive.servicios[idx] : null;
            if (servicioDetalle) {
                setServicioPagoSeleccionado({ servicio, servicioDetalle, idx });
                const eraOtroServicio = servicioPagoSeleccionado?.servicio && String(servicioPagoSeleccionado.servicio._id || servicioPagoSeleccionado.servicio) !== String(servicioId);
                if (eraOtroServicio) {
                    setVentaExistente(null);
                    setSelectedPromociones([]);
                    setSelectedProducts([]);
                }
            }
        }
    };

	// Al hacer clic en una card de servicio (varios servicios en la cita), activar ese servicio como "actual", su profesional y variantes de la cita para ese servicio
	const handleServiceCardClick = (servicio) => {
		if (!citaActive?.servicios?.length || citaActive.servicios.length <= 1) return;
		const servicioId = servicio._id || servicio;
		const servicioIdStr = String(servicioId);
		const idx = (citaActive.servicios || []).findIndex(sd =>
			String(sd?.servicio?._id || sd?.servicio) === servicioIdStr
		);
		const servicioDetalle = idx >= 0 ? citaActive.servicios[idx] : null;
		if (servicioDetalle) {
			setServicioPagoSeleccionado({ servicio, servicioDetalle, idx });
			// Activar el profesional de este servicio en la cita
			const profId = servicioDetalle.profesional?._id ?? servicioDetalle.profesional;
			if (profId && profesionales?.length) {
				const prof = profesionales.find(p => String(p._id || p) === String(profId));
				setSelectedProfesional(prof ? [prof] : []);
			} else {
				setSelectedProfesional([]);
			}
			// Mantener variantes de los servicios ya seleccionados y añadir las del servicio clicado (unión)
			if (citaActive.variantes && citaActive.variantes.length > 0 && variantes?.length > 0) {
				const idsOtrosServicios = (selectedServices || [])
					.map(s => s._id || s)
					.filter(id => String(id) !== servicioIdStr);
				const variantesDeOtros = (selectedVariantes || []).filter(v => {
					if (!v) return false;
					return (v.servicios || []).some(sId => idsOtrosServicios.some(oid => String(sId?._id || sId) === String(oid)));
				});
				const variantesDelServicioClicadoRaw = citaActive.variantes.filter(varianteIdOrObj => {
					const varianteId = varianteIdOrObj._id || varianteIdOrObj;
					const varianteCompleta = variantes.find(v => String(v._id || v) === String(varianteId));
					if (!varianteCompleta) return false;
					return (varianteCompleta.servicios || []).some(sId => String(sId?._id || sId) === servicioIdStr);
				});
				const variantesDelServicioClicado = variantesDelServicioClicadoRaw
					.map(varianteIdOrObj => variantes.find(v => String(v._id || v) === String(varianteIdOrObj._id || varianteIdOrObj)))
					.filter(Boolean);
				const porId = new Map();
				variantesDeOtros.forEach(v => porId.set(String(v._id || v), v));
				variantesDelServicioClicado.forEach(v => porId.set(String(v._id || v), v));
				setSelectedVariantes(Array.from(porId.values()));
			} else {
				setSelectedVariantes([]);
			}
			const eraOtroServicio = servicioPagoSeleccionado?.servicio && String(servicioPagoSeleccionado.servicio._id || servicioPagoSeleccionado.servicio) !== servicioIdStr;
			if (eraOtroServicio) {
				setVentaExistente(null);
				setSelectedPromociones([]);
				setSelectedProducts([]);
			}
		}
	};
	const handleProfesionalSelected = (profesionalOrArray) => {
		const next = Array.isArray(profesionalOrArray) ? profesionalOrArray : (profesionalOrArray ? [profesionalOrArray] : []);
		setSelectedProfesional(next);
	};
	const handlePromocionesSelected = (promosSelected) => {		
        setSelectedPromociones(promosSelected);		
    };

	const handleVariantesChanged = (variantes) => {
        setSelectedVariantes(variantes);    		
    }
	const handleMetodoPagoSelected = (metodoPago) => {
        setMetodoPago(metodoPago);
    }

    // EX-515: en modo creación los métodos son toggles independientes y reparten el total
    const toggleMetodoMultipago = (metodo) => {
        const metodoId = metodo._id;
        const yaActivo = metodoPago.some(m => m._id === metodoId);
        const totalNum = parseFloat(total) || 0;
        const saldoCliente = Number(clienteData.saldoMonedero) || 0;

        if (yaActivo) {
            const siguientesMetodos = metodoPago.filter(m => m._id !== metodoId);
            setMetodoPago(siguientesMetodos);
            setRepartoPagos(prev => {
                const next = { ...prev };
                delete next[metodoId];
                return next;
            });
            return;
        }

        const siguientesMetodos = [...metodoPago, metodo];
        setMetodoPago(siguientesMetodos);
        setRepartoPagos(prev => {
            const next = { ...prev };
            const sumaPrevia = Object.values(next).reduce((acumulado, valor) => acumulado + (Number(valor) || 0), 0);
            const restante = Math.max(0, totalNum - sumaPrevia);

            if (siguientesMetodos.length === 1) {
                next[metodoId] = metodoId === 'Monedero'
                    ? Math.min(saldoCliente, totalNum)
                    : totalNum;
                return next;
            }
            if (metodoId === 'Monedero') {
                next[metodoId] = Math.min(saldoCliente, restante);
            } else {
                next[metodoId] = restante > 0 ? restante : 0;
            }
            return next;
        });
    };

    const handleImporteRepartoChange = (metodoId, rawValue) => {
        if (!/^-?\d*\.?\d*$/.test(rawValue)) return;
        if (rawValue.includes('.') && rawValue.split('.').length > 2) return;
        if (rawValue.includes('.')) {
            const decimal = rawValue.split('.')[1];
            if (decimal && decimal.length > 2) return;
        }
        repartoEditadoManualmenteRef.current = true;
        setRepartoPagos(prev => ({ ...prev, [metodoId]: rawValue }));
    };

    // EX-517: `esModoMultipago` representa "sin venta existente". El desglose se renderiza
    // siempre que haya >=1 metodo seleccionado.
    const esModoMultipago = !ventaExistente;
    const totalNumerico = parseFloat(total) || 0;
    const saldoNumerico = Number(clienteData.saldoMonedero) || 0;
    const sumaReparto = useMemo(() => {
        return metodoPago.reduce((acumulado, m) => acumulado + (Number(repartoPagos[m._id]) || 0), 0);
    }, [metodoPago, repartoPagos]);
    const sumaRepartoRedondeada = Math.round(sumaReparto * 100) / 100;
    const totalRedondeado = Math.round(totalNumerico * 100) / 100;
    const importeMonederoAsignado = Number(repartoPagos['Monedero']) || 0;
    const monederoActivo = metodoPago.some(m => m._id === 'Monedero');
    // EX-517: en modo edicion (venta existente y NO flujo sucursal pendiente) la validacion
    // de monedero no aplica — la vista es solo lectura, no se guarda nada.
    const metodoPagoCitaStr = String(citaActive?.metodoPago || '');
    const esFlujoSucursalPendiente = !!ventaExistente
        && !!citaActive
        && !citaActive.pagada
        && metodoPagoCitaStr.includes('Monedero App')
        && metodoPagoCitaStr.includes('Pago en sucursal');
    // EX-518: cita parcialmente pagada tras anular una venta de un multipago. El modal pasa
    // a modo "completar pago": las filas existentes quedan bloqueadas pero el usuario puede
    // añadir métodos nuevos para cubrir el pendiente.
    const esModoCompletarPago = !!ventaExistente
        && !!citaActive
        && citaActive.pagada === false
        && !esFlujoSucursalPendiente;
    const esVistaSoloLectura = !!ventaExistente && !esFlujoSucursalPendiente && !esModoCompletarPago;

    // EX-611: los datáfonos salen del endpoint autenticado del POS, NO del store de sucursales ni
    // de `citaActive.sucursal`: los dos se pueblan con proyecciones que no traen `datafonos` (la
    // del store porque su endpoint es público y no puede exponer los terminales del comercio).
    const datafonosSucursal = useMemo(() => {
        // Según la rama de prefill, `selectedSucursal[0]` es el objeto de la cita o el id crudo.
        const sucursalId = selectedSucursal[0]?._id || selectedSucursal[0];
        return datafonosDeSucursal(sucursalesConDatafonos, sucursalId);
    }, [sucursalesConDatafonos, selectedSucursal]);
    const datafonosDisponibles = useMemo(() => datafonosActivos(datafonosSucursal), [datafonosSucursal]);
    // EX-619: con varios terminales activos no hay preselección. El predeterminado sigue siendo el
    // que usa el backend cuando el cobro no nombra ninguno, pero desde el panel se elige: dejar el
    // desplegable apuntando al predeterminado hacía que confirmar sin mirarlo cobrara en él.
    // Con uno solo no hay nada que elegir y es ese.
    const datafonoParaCobro = datafonoSeleccionado
        || (datafonosDisponibles.length === 1 ? datafonosDisponibles[0] : null);
    // EX-605: la venta que el backend acepta completar es la que nació con "Pago en sucursal App",
    // y es exactamente la que la cita publica como `ventaPendienteSucursal` (mismo criterio en
    // `GET /api/citas/:id`). NO vale `ventaExistente`: es la más antigua de la cita, que en este
    // flujo suele ser la del monedero y el backend la rechazaría por no estar pendiente.
    const ventaPendienteACobrar = citaActive?.ventaPendienteSucursal?._id || null;
    // Y el importe del cobro es el de esa venta, no el total del formulario: ver `handleSubmit`.
    const importePendienteSucursal = Number(citaActive?.ventaPendienteSucursal?.importe);
    const hayPendienteCobrable = !!ventaPendienteACobrar
        && Number.isFinite(importePendienteSucursal)
        && importePendienteSucursal > 0;
    // El flujo de EX-517 completa una venta ya existente, y desde EX-596 el cobro con datáfono
    // sabe hacerlo sin duplicarla (`tipoPayload: 'actualizacion'`). Ese payload es de forma simple
    // —un método y un importe—, así que solo se enruta el pendiente que se cobra íntegro con
    // tarjeta; repartido entre varios métodos sigue por el camino manual de siempre.
    const pendienteCobrableEnDatafono = !esFlujoSucursalPendiente
        || (hayPendienteCobrable
            && metodoPago.length === 1
            && metodoPago[0]?._id === METODO_PAGO_TARJETA);
    // EX-611: fuera de los cobros que pueden ir al terminal el enrutado no se pregunta siquiera.
    // Una vista de solo lectura o un pendiente repartido entre varios métodos se anotan a mano
    // pase lo que pase con los datáfonos, así que tampoco tienen nada de lo que avisar.
    const enrutadoDelCobro = (esVistaSoloLectura || !pendienteCobrableEnDatafono)
        ? ENRUTADO_MANUAL
        : enrutadoCobro({
            metodosPago: metodoPago,
            datafonos: datafonosSucursal,
            resolucion: resolucionDatafonos,
            decision: viaCobro,
        });
    const debeEnrutarADatafono = enrutadoDelCobro === ENRUTADO_DATAFONO;
    // EX-619: hay terminal con el que cobrar y no consta por dónde va. Desde EX-622 el cobro
    // arranca en "Por datáfono", así que es una salvaguarda: si la decisión llegara vacía, no se
    // lanza nada, ni al datáfono ni al registro manual.
    const decisionCobroPendiente = enrutadoDelCobro === ENRUTADO_PENDIENTE_DECISION;
    // La pregunta se ofrece mientras la decisión sea del operario, también después de contestarla:
    // elegir "Anotar a mano" no puede quitarle la opción de volver al datáfono.
    const eleccionViaCobroDisponible = enrutadoDelCobro === ENRUTADO_DATAFONO
        || enrutadoDelCobro === ENRUTADO_PENDIENTE_DECISION
        || (viaCobro === DECISION_MANUAL
            && !esVistaSoloLectura
            && pendienteCobrableEnDatafono
            && enrutadoCobro({
                metodosPago: metodoPago,
                datafonos: datafonosSucursal,
                resolucion: resolucionDatafonos,
            }) === ENRUTADO_PENDIENTE_DECISION);
    // Y elegido el datáfono con varios activos, tampoco se cobra hasta saber en cuál.
    const faltaElegirDatafono = debeEnrutarADatafono && !datafonoParaCobro;
    // Se está cobrando con tarjeta y no se sabe si esta sucursal cobra en el terminal: ni se
    // enruta al datáfono ni se anota una venta manual, se dice.
    const enrutadoSinResolver = enrutadoDelCobro === ENRUTADO_SIN_RESOLVER;

    // Al cambiar de sucursal el datáfono elegido deja de existir y la elección se descarta.
    useEffect(() => {
        setDatafonoSeleccionado(seleccionado => {
            if (!seleccionado) return null;
            const sigueDisponible = datafonosDisponibles.some(d => d.deviceId === seleccionado.deviceId);
            return sigueDisponible ? seleccionado : null;
        });
        // EX-619: y con ella la decisión de por dónde cobrar. Cambiar de sucursal cambia si hay
        // terminal y cuál, así que lo elegido para la anterior no dice nada de esta.
        // EX-622: se vuelve a la salida de partida, no a "sin decidir".
        setViaCobro(DECISION_VIA_COBRO_INICIAL);
    }, [datafonosDisponibles]);

    const monederoExcedeSaldo = !esVistaSoloLectura && monederoActivo && importeMonederoAsignado > saldoNumerico;
    const sumaCuadra = sumaRepartoRedondeada === totalRedondeado;
    const sumaImportesExistentes = useMemo(() => {
        return metodoPago
            .filter(m => !!m.ventaId)
            .reduce((acc, m) => acc + (Number(repartoPagos[m._id]) || 0), 0);
    }, [metodoPago, repartoPagos]);
    const importePendiente = Math.max(0, Math.round((totalNumerico - sumaImportesExistentes) * 100) / 100);
    const tieneFilasNuevas = metodoPago.some(m => !m.ventaId && Number(repartoPagos[m._id] || 0) > 0);

    const repartoValido = sumaCuadra && !monederoExcedeSaldo && totalNumerico > 0;
    // Venta nueva y pendiente de sucursal anotan todos los métodos elegidos; "completar pago"
    // solo las filas nuevas. Cualquier otro modo es de solo lectura y no anota nada.
    const anotaMetodosSeleccionados = esModoMultipago || esFlujoSucursalPendiente;
    const hayMetodosQueAnotar = anotaMetodosSeleccionados
        ? metodoPago.length > 0
        : esModoCompletarPago && tieneFilasNuevas;
    const botonAnotarHabilitado = hayMetodosQueAnotar && repartoValido;

    // EX-517/EX-518: en modo solo lectura ninguna fila es editable. En modo "completar pago"
    // (EX-518) las filas con ventaId siguen siendo no editables (corresponden a ventas ya
    // cobradas) pero las filas nuevas sí permiten editar importe.
    const esFilaNoEditable = (fila) => {
        if (esVistaSoloLectura) return true;
        if (!fila?.ventaId) return false;
        if (esModoCompletarPago) return true;
        const raw = metodosOriginalesPorVentaRef.current?.[fila.ventaId] || '';
        return String(raw).includes('Pago en sucursal App');
    };

    // EX-515: al abrir el modal en modo creación, si el cliente tiene saldo en monedero
    // y hay un total a cobrar, preseleccionar Monedero con `min(saldo, total)`. Solo se
    // ejecuta una vez por apertura; si el user lo deselecciona o edita el reparto, no se
    // vuelve a aplicar hasta cerrar y reabrir el modal.
    useEffect(() => {
        if (!activeModalVentas) {
            monederoPreseleccionadoRef.current = false;
            repartoEditadoManualmenteRef.current = false;
            return;
        }
        if (monederoPreseleccionadoRef.current) return;
        if (!esModoMultipago) return;
        if (metodoPago.length > 0) return;
        if (totalNumerico <= 0) return;
        if (saldoNumerico <= 0) return;

        const monedero = METODOS_PAGO.find(m => m._id === 'Monedero');
        if (!monedero) return;

        monederoPreseleccionadoRef.current = true;
        setMetodoPago([monedero]);
        setRepartoPagos({ Monedero: Math.min(saldoNumerico, totalNumerico) });
    }, [activeModalVentas, esModoMultipago, metodoPago.length, totalNumerico, saldoNumerico]);

    // Cuando solo hay un método de pago seleccionado y el usuario no ha tocado el reparto,
    // re-sincronizar el importe asignado con el total. Cubre el caso de "Pagar cita completa"
    // donde el total cambia tras la auto-selección de Monedero (variantes que se añaden al
    // total en un render posterior, productos añadidos después, etc.). Tras guardar la venta
    // (`ventaCompletada`) no se vuelve a tocar el reparto: refleja lo realmente cobrado.
    useEffect(() => {
        if (esVistaSoloLectura) return;
        if (ventaCompletada) return;
        if (metodoPago.length !== 1) return;
        if (repartoEditadoManualmenteRef.current) return;
        const unicoMetodo = metodoPago[0];
        if (unicoMetodo?.ventaId) return;
        const metodoId = unicoMetodo._id;
        const nuevoImporte = metodoId === 'Monedero'
            ? Math.min(saldoNumerico, totalNumerico)
            : totalNumerico;
        setRepartoPagos(prev => {
            const actual = Number(prev[metodoId]) || 0;
            if (Math.abs(actual - nuevoImporte) < 0.001) return prev;
            return { ...prev, [metodoId]: nuevoImporte };
        });
    }, [totalNumerico, saldoNumerico, metodoPago, esVistaSoloLectura, ventaCompletada]);

    const handleClose = () => {
        onClose();
    };

    /**
     * EX-595: la cancelación real se hace pulsando Cancelar en el propio datáfono; aquí solo se
     * registra la intención. El polling sigue escuchando, porque el cliente todavía puede
     * completar el pago en el terminal y ese pago no se puede ignorar.
     */
    const solicitarCancelacionCobro = async () => {
        const pagoId = estadoCobroDatafono?.pagoId;
        if (!pagoId) return;
        setEstadoCobroDatafono(estado => ({ ...estado, estado: ESTADO_CANCELACION_SOLICITADA }));
        await dispatch(startCancelarCobro(pagoId));
    };

    const cerrarTrasDesenlaceDatafono = () => {
        setDesenlaceCobroDatafono(null);
        setEstadoCobroDatafono(null);
        handleClose();
    };
	
	const [fechaCalendar, setFechaCalendar] = useState(citaActive?.fecha ? moment(citaActive.fecha) : moment());
	const [selectDate, setSelectDate] = useState(true);
	const [timeCalendar, setTimeCalendar] = useState(citaActive?.fecha ? moment(citaActive.fecha) : moment());
	const [selectTime, setSelectTime] = useState(true);

    const handleUsuarioSelected = usuario => {
        dispatch(activeUsuario(usuario._id, usuario));
        setSelectUsuario({
            _id: usuario._id,
            selected: usuario,
            visible: true,
            active: false
        });
        setClienteData({
            nombre: usuario.nombre || '',
            apellidos: usuario.apellidos || '',
			saldoMonedero: usuario.saldoMonedero || 0
        });
    };

    const resetForm = () => {
        setVentaExistente(null);
        setVentaCompletada(false);
        setCitaIdParaTicket(null);
        setEnviandoTicket(false);
        setTicketEnviado(false);
        setTotal(0);
        setClienteData({
            nombre: '',
            apellidos: '',
			saldoMonedero: 0
        });
        dispatch(unactiveUsuario());
        setSelectUsuario({
            selected: null,
            visible: true,
            active: false
        });
        setSelectedServices([]);
        setSelectedVariantes([]);
        setSelectedPromociones([]);
        setSelectedProfesional([]);
        setSelectedSucursal([]);
        setMetodoPago([]);
        setRepartoPagos({});
        setSelectedProducts([]);
        setServicioPagoSeleccionado(null);
        setServiciosSeleccionadosParaPago([]);
        setFechaCalendar(moment());
        setTimeCalendar(moment());
    };

    // useEffect al abrir el modal: solo resetear cuando no hay cita ni usuario preseleccionado.
    // La carga de cita (incl. multi-servicio) la maneja el useEffect con [citaActive, usuarioActive].
    useEffect(() => {
        if (activeModalVentas && !citaActive && !(usuarioActive && usuarioActive._id)) {
            resetForm();
        }
    }, [activeModalVentas]);

    const handleProductsChanged = (products) => {
        setSelectedProducts(products);        
    };

    // --- EX-471: nuevos estados para el layout 3 zonas ---
    const [activeTab, setActiveTab] = useState('servicios');
    const [searchProducto, setSearchProducto] = useState('');

    useEffect(() => {
        if (!activeModalVentas) {
            setActiveTab('servicios');
            setSearchProducto('');
            setProductQuantities({});
            setVentaCompletada(false);
            setCitaIdParaTicket(null);
            setEnviandoTicket(false);
        }
    }, [activeModalVentas]);

    const filteredProductos = useMemo(() => {
        if (!productos) return [];
        if (!searchProducto.trim()) return productos;
        const q = searchProducto.trim().toLowerCase();
        return productos.filter(p => (p.titulo || p.nombre || '').toLowerCase().includes(q));
    }, [productos, searchProducto]);

    // Mostrar siempre todos los servicios del catálogo en el selector
    const serviciosParaVenta = useMemo(() => servicios || [], [servicios]);

    // Si hay cita, solo los servicios de esta cita son seleccionables; el resto se deshabilitan
    const idsServiciosDeLaCita = useMemo(() => {
        if (!citaActive) return null;
        const ids = new Set();
        (citaActive.servicios || []).forEach(s => {
            const id = s?._id ?? s;
            if (id) ids.add(String(id));
        });
        (citaActive.servicios || []).forEach(sd => {
            const id = sd?.servicio?._id ?? sd?.servicio;
            if (id) ids.add(String(id));
        });
        return ids.size > 0 ? Array.from(ids) : null;
    }, [citaActive]);

    const handleVarianteToggle = (variante) => {
        const isSelected = selectedVariantes.some(v => String(v._id || v) === String(variante._id));
        const next = isSelected
            ? selectedVariantes.filter(v => String(v._id || v) !== String(variante._id))
            : [...selectedVariantes, variante];
        handleVariantesChanged(next);
    };

    const handleProductoAdd = (producto) => {
        const qty = (productQuantities[producto._id] || 0) + 1;
        setProductQuantities(prev => ({ ...prev, [producto._id]: qty }));
        const alreadyIn = selectedProducts.some(p => String(p._id || p) === String(producto._id));
        if (!alreadyIn) {
            setSelectedProducts(prev => [...prev, producto]);
        }
    };

    const handleProductoRemove = (producto) => {
        const qty = (productQuantities[producto._id] || 0) - 1;
        if (qty <= 0) {
            setProductQuantities(prev => { const n = { ...prev }; delete n[producto._id]; return n; });
            setSelectedProducts(prev => prev.filter(p => String(p._id || p) !== String(producto._id)));
        } else {
            setProductQuantities(prev => ({ ...prev, [producto._id]: qty }));
        }
    };

    const handleRemoveServicio = (servicio) => {
        handleServicesChanged(selectedServices.filter(s => String(s._id || s) !== String(servicio._id)));
    };

    const handleRemoveProducto = (producto) => {
        setProductQuantities(prev => { const n = { ...prev }; delete n[producto._id]; return n; });
        setSelectedProducts(prev => prev.filter(p => String(p._id || p) !== String(producto._id)));
    };

    const handleProductosSelectedForMobile = (newList) => {
        setSelectedProducts(newList || []);
        setProductQuantities(prev => {
            const next = { ...prev };
            (newList || []).forEach(p => {
                const id = p._id || p;
                if (!prev[id]) next[id] = 1;
            });
            Object.keys(next).forEach(id => {
                if (!(newList || []).some(p => String(p._id || p) === String(id))) delete next[id];
            });
            return next;
        });
    };

    const PAYMENT_LABELS = {
        'Pago en efectivo': 'Efectivo',
        'Pago Tarjeta': 'Tarjeta',
        'Monedero': 'Monedero',
    };

    const rawMetodoPagoOrigen = ventaExistente?.metodoPago || citaActive?.metodoPago || '';
    const getPaymentLabel = (metodoId, isActive) => {
        let label;
        if (isActive && metodoId === 'Monedero' && String(rawMetodoPagoOrigen).includes('Monedero App')) {
            label = rawMetodoPagoOrigen.includes('Pago en sucursal') ? 'Monedero (desde app) + Sucursal' : 'Monedero (desde app)';
        } else if (isActive && metodoId === 'Pago Tarjeta' && (String(rawMetodoPagoOrigen) === 'Pago Tarjeta App' || String(rawMetodoPagoOrigen).includes('Pago Tarjeta App'))) {
            label = rawMetodoPagoOrigen.includes('Monedero App') ? 'Tarjeta (desde app) + Monedero' : 'Tarjeta (desde app)';
        } else {
            label = PAYMENT_LABELS[metodoId] || metodoId;
        }
        return label;
    };

    const rawStr = String(rawMetodoPagoOrigen);
    const tieneMonederoApp = rawStr.includes('Monedero App');
    const tieneTarjetaApp = rawStr.includes('Pago Tarjeta App');
    const tienePagoEnSucursal = rawStr.includes('Pago en sucursal');
    let conceptoLabelParaLectura = '';
    if (tieneMonederoApp && tieneTarjetaApp) {
        conceptoLabelParaLectura = 'Concepto: Monedero (desde app) + Tarjeta (desde app)';
    } else if (tieneMonederoApp && tienePagoEnSucursal) {
        conceptoLabelParaLectura = 'Concepto: Monedero (desde app) + Pendiente en sucursal';
    } else if (tieneMonederoApp) {
        conceptoLabelParaLectura = 'Concepto: Monedero (desde app)';
    } else if (tieneTarjetaApp) {
        conceptoLabelParaLectura = 'Concepto: Tarjeta (desde app)';
    }

    return (
        <>
            <div className={`modal-ventas ${activeModalVentas ? 'active' : ''}`}>
                <div className="mv-wrapper">

                    {/* Header */}
                    <div className="mv-header">
                        <h3 className="mv-header__title">
                            Venta
                        </h3>
                        <button className="mv-header__close" onClick={handleClose}>
                            <CloseIcon color="#6366F1" />
                        </button>
                    </div>

                    {cargandoVentaExistente ? (
                        <div className="mv-body" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '200px' }}>
                            <p style={{ fontSize: '16px', color: '#6366F1' }}>Cargando...</p>
                        </div>
                    ) : (
                    <>
                    {/* Body 3 zonas */}
                    <div className="mv-body">

                        {/* ZONA IZQUIERDA: mobile = selects arriba; desktop = tabs + catálogo cards */}
                        <div className="mv-col-left">
                            {/* Mobile: selectores de servicio y productos (como en muestra) */}
                            <div className="mv-mobile-selects">
                                <div className="mv-mobile-select-row">
                                    <DropdownMultipleServicios
                                        key={activeModalVentas ? 'servicios-open' : 'servicios-closed'}
                                        services={serviciosParaVenta}
                                        selectedServices={selectedServices}
                                        handleServicesChanged={handleServicesChanged}
                                        variant="dropdown"
                                        onCardClick={citaActive?.servicios?.length > 1 ? handleServiceCardClick : undefined}
                                        enabledServiceIds={!citaActive ? null : (citaActive.servicios?.length === 1 || (citaActive.servicios?.length > 1 && selectedServices?.length === 1)) ? null : idsServiciosDeLaCita}
                                    />
                                </div>
                                <div className="mv-mobile-select-row">
                                    <DropdownAll
                                        items={productos || []}
                                        itemsSelected={selectedProducts}
                                        handleItemsSelected={handleProductosSelectedForMobile}
                                        texto="Selecciona productos"
                                        className="mv-mobile-select-productos"
                                        noInlineStyles
                                    />
                                </div>
                            </div>
                            {/* Desktop: tabs + catálogo con cards */}
                            <div className="mv-catalog">
                                    <div className="mv-tabs">
                                        <button
                                            type="button"
                                            className={`mv-tabs__tab ${activeTab === 'servicios' ? 'mv-tabs__tab--active' : ''}`}
                                            onClick={() => setActiveTab('servicios')}
                                        >
                                            Servicios
                                        </button>
                                        <button
                                            type="button"
                                            className={`mv-tabs__tab ${activeTab === 'productos' ? 'mv-tabs__tab--active' : ''}`}
                                            onClick={() => setActiveTab('productos')}
                                        >
                                            Productos
                                        </button>
                                    </div>
                                    {activeTab === 'servicios' && (
                                        <div className="mv-body-services">
                                            <DropdownMultipleServicios
                                                key={activeModalVentas ? 'servicios-open' : 'servicios-closed'}
                                                services={serviciosParaVenta}
                                                selectedServices={selectedServices}
                                                handleServicesChanged={handleServicesChanged}
                                                variant="cards"
                                                onCardClick={citaActive?.servicios?.length > 1 ? handleServiceCardClick : undefined}
                                                enabledServiceIds={!citaActive ? null : (citaActive.servicios?.length === 1 || (citaActive.servicios?.length > 1 && selectedServices?.length === 1)) ? null : idsServiciosDeLaCita}
                                            />
                                        </div>
                                    )}
                                    {activeTab === 'productos' && (
                                        <div className="mv-body-products">
                                            <div className="mv-search">
                                                <input
                                                    type="text"
                                                    placeholder="Buscar productos..."
                                                    value={searchProducto}
                                                    onChange={(e) => setSearchProducto(e.target.value)}
                                                />
                                            </div>
                                            <div className="mv-products-grid servicios-grid-reserva">
                                                {filteredProductos.map((producto) => {
                                                    const qty = productQuantities[producto._id] || 0;
                                                    const isSelected = selectedProducts.some(p => String(p._id || p) === String(producto._id));
                                                    return (
                                                        <div
                                                            key={producto._id}
                                                            className={`producto-card-venta ${isSelected ? 'producto-card-venta--selected' : ''}`}
                                                        >
                                                            <div
                                                                className="producto-card-venta__img"
                                                                style={(producto.imagenPrincipal || producto.img?.[0]) ? { backgroundImage: `url(${producto.imagenPrincipal || producto.img[0]})` } : {}}
                                                            />
                                                            <div className="producto-card-venta__body">
                                                                <p className="producto-card-venta__nombre">{producto.titulo || producto.nombre || 'Producto'}</p>
                                                                <div className="producto-card-venta__meta">
                                                                    <span className="producto-card-venta__meta-item">
                                                                        <ServicePriceIcon />
                                                                        {formatCurrency(producto.precio || 0)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                className="producto-card-venta__add"
                                                                style={colores?.colorPrincipal ? { backgroundColor: colores.colorPrincipal } : {}}
                                                                onClick={(e) => { e.stopPropagation(); handleProductoAdd(producto); }}
                                                                aria-label="Añadir producto"
                                                                title="Añadir"
                                                            >
                                                                <span>+</span>
                                                            </button>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}
                                </div>
                        </div>

                        {/* ZONA CENTRAL: resumen del pedido */}
                        <div className="mv-col-center">
                            {!citaActive && !selectUsuario.selected ? (
                                <div className="mv-cliente-select">
                                    <DropdownClientes
                                        texto="Selecciona cliente"
                                        selectUsuario={selectUsuario}
                                        setSelectUsuario={setSelectUsuario}
                                        handleUsuarioSelected={handleUsuarioSelected}
                                        usuarios={usuarios}
                                    />
                                </div>
                            ) : (
                                <>
                                    <p className="mv-client-name">
                                        <span className="mv-label">Cliente:&nbsp;</span>
                                        <span className="mv-value">
                                            {`${clienteData.nombre} ${clienteData.apellidos}`}
                                        </span>
                                    </p>
                                    <p className="mv-client-saldo">
                                        Saldo disponible: {clienteData.saldoMonedero != null ? Number(clienteData.saldoMonedero).toFixed(2) : '0.00'}€
                                    </p>
                                </>
                            )}

                            <div className="mv-section">
                                <p className="mv-section-label">RESUMEN</p>

                                {(ventaModoCitaCompleta && citaActive?.servicios?.length
                                    ? citaActive.servicios.map(sd => ({
                                        _id: sd?.servicio?._id ?? sd?.servicio,
                                        nombre: sd?.nombre,
                                        precio: sd?.precio,
                                        ...sd,
                                    }))
                                    : selectedServices
                                ).map((servicio, i) => {
                                    const servicioResuelto = (servicios?.length && (servicio?.precio == null || servicio?.nombre == null))
                                        ? (servicios.find(s => String(s._id || s) === String(servicio._id || servicio)) || servicio)
                                        : servicio;
                                    const nombre = servicioResuelto?.nombre ?? servicio?.nombre;
                                    const precio = servicioResuelto?.precio != null ? servicioResuelto.precio : (servicio?.precio ?? 0);
                                    return (
                                        <div key={servicio?._id || i} className="mv-resumen-item">
                                            <span className="mv-resumen-nombre">{nombre || 'Servicio'}</span>
                                            <span className="mv-resumen-precio">{formatCurrency(precio)} €</span>
                                            {!ventaModoCitaCompleta && (
                                                <button className="mv-resumen-remove" onClick={() => handleRemoveServicio(servicio)}>×</button>
                                            )}
                                        </div>
                                    );
                                })}

                                {selectedProducts.map((producto, i) => {
                                    const qty = productQuantities[producto._id] || 1;
                                    return (
                                        <div key={i} className="mv-resumen-item mv-resumen-item--product">
                                            <div className="mv-resumen-product-top">
                                                <span className="mv-resumen-nombre">{producto.titulo || producto.nombre}</span>
                                                <button className="mv-resumen-remove" onClick={() => handleRemoveProducto(producto)}>×</button>
                                            </div>
                                            <div className="mv-resumen-product-bottom">
                                                <span className="mv-resumen-qty">× {qty}</span>
                                                <span className="mv-resumen-precio">{formatCurrency((producto.precio || 0) * qty)} €</span>
                                                <div className="mv-resumen-counter">
                                                    <button type="button" onClick={() => handleProductoRemove(producto)} aria-label="Quitar una unidad">−</button>
                                                    <span>{qty}</span>
                                                    <button type="button" onClick={() => handleProductoAdd(producto)} aria-label="Añadir una unidad">+</button>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            {/* Variantes: mismo componente que Reserva (chips) */}
                            <MultiSelectionVariantes
                                variantes={variantes}
                                selectedServicio={selectedServices}
                                selectedVariantes={selectedVariantes}
                                handleVariantesChanged={handleVariantesChanged}
                                variant="chips"
                            />

                            {/* Profesionales como avatares */}
                            <div className="mv-section">
                                <p className="mv-section-label">PROFESIONAL</p>
                                <div className="mv-profesionales-row">
                                    {profesionales.map(prof => {
                                        const isSelected = selectedProfesional.some(p => String(p._id || p) === String(prof._id));
                                        return (
                                            <div
                                                key={prof._id}
                                                className={`mv-prof-item ${isSelected ? 'mv-prof-item--selected' : ''}`}
                                                onClick={() => handleProfesionalSelected([prof])}
                                                title={prof.nombre}
                                            >
                                                <AvatarProfesional prof={prof} clase="mv-prof-avatar" />
                                                <p className="mv-prof-name">{prof.nombre}</p>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            {/* Sucursal: mismo componente que Reserva (pills) */}
                            <DropdownSucursales
                                selectServicio={selectedServices}
                                texto="Selecciona una sucursal *"
                                handleSucursalSelected={(suc) => handleSucursalSelected(suc)}
                                selectSucursal={{
                                    selected: selectedSucursal?.[0] || null,
                                    visible: true,
                                }}
                                editCita={true}
                                variant="pills"
                            />

                            {/* Promociones */}
                            <DropdownAll
                                items={promociones}
                                handleItemsSelected={handlePromocionesSelected}
                                itemsSelected={selectedPromociones}
                                texto="Selecciona descuentos"
                                className="mv-descuentos-select"
                                noInlineStyles
                            />
                        </div>

                        {/* ZONA DERECHA: método de pago + fecha/hora + barra importe/botón (todo en flujo, sin fijo) */}
                        <div className="mv-col-right">
                            <p className="mv-section-label">MÉTODO DE PAGO</p>
                            {conceptoLabelParaLectura ? (
                                <p className="mv-concepto-pago" style={{ fontSize: '12px', color: '#6366F1', marginBottom: '8px' }}>{conceptoLabelParaLectura}</p>
                            ) : null}
                            <div className="mv-payment-grid">
                                {METODOS_PAGO.map(metodo => {
                                    const isActive = metodoPago.some(m => m._id === metodo._id);
                                    // EX-518: en modo completar pago, los métodos que ya tienen una fila
                                    // existente (con ventaId) quedan bloqueados — no se puede tocar la
                                    // venta ya cobrada. El usuario solo puede añadir métodos nuevos.
                                    const tieneFilaExistente = esModoCompletarPago && metodoPago.some(m => m._id === metodo._id && m.ventaId);
                                    const botonDeshabilitado = esVistaSoloLectura || tieneFilaExistente;
                                    const onClickPago = botonDeshabilitado ? undefined : () => toggleMetodoMultipago(metodo);
                                    return (
                                        <button
                                            key={metodo._id}
                                            className={`mv-payment-card ${isActive ? 'mv-payment-card--active' : ''}`}
                                            onClick={onClickPago}
                                            disabled={botonDeshabilitado}
                                        >
                                            <span className={`mv-payment-icon ${metodo._id === 'Pago en efectivo' ? 'mv-payment-icon--euro' : ''} ${metodo._id === 'Monedero' ? 'mv-payment-icon--wallet' : ''}`}>
                                                {metodo._id === 'Pago Tarjeta' && <CreditCardIcon color="currentColor" />}
                                                {metodo._id === 'Monedero' && <WalletIcon color="currentColor" />}
                                                {metodo._id === 'Pago en efectivo' && <EuroIcon color="currentColor" />}
                                            </span>
                                            <span className="mv-payment-label">{getPaymentLabel(metodo._id, isActive)}</span>
                                        </button>
                                    );
                                })}
                            </div>

                            {/* EX-611: la configuración de datáfonos no se ha podido leer y se
                                está cobrando con tarjeta. El aviso se queda a la vista mientras
                                dure: el pago no se anota hasta saber si va al terminal. */}
                            {enrutadoSinResolver && resolucionDatafonos === RESOLUCION_ERROR && (
                                <div className="mv-datafono-aviso">
                                    <p>
                                        No se ha podido comprobar si esta sucursal cobra con datáfono.
                                        Hasta saberlo el pago no se anota, para no dar por cobrada una
                                        tarjeta que no ha pasado por el terminal.
                                    </p>
                                    <button type="button" onClick={reintentarDatafonos}>
                                        Volver a comprobar
                                    </button>
                                </div>
                            )}

                            {/* EX-619: la sucursal tiene terminal, pero eso no decide este cobro.
                                Se pregunta siempre que haya datáfono activo, con uno o con varios.
                                EX-622: "Por datáfono" viene marcado de salida. El camino manual es
                                una salida de pleno derecho, no el residuo de que falle algo. */}
                            {eleccionViaCobroDisponible && (
                                <div className="mv-datafono-via">
                                    <span className="mv-field__label">COBRO CON TARJETA</span>
                                    <div className="mv-datafono-via__opciones">
                                        <label>
                                            <input
                                                type="radio"
                                                name="mv-via-cobro"
                                                value={DECISION_DATAFONO}
                                                checked={viaCobro === DECISION_DATAFONO}
                                                onChange={() => setViaCobro(DECISION_DATAFONO)}
                                            />
                                            Por datáfono
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="mv-via-cobro"
                                                value={DECISION_MANUAL}
                                                checked={viaCobro === DECISION_MANUAL}
                                                onChange={() => setViaCobro(DECISION_MANUAL)}
                                            />
                                            Anotar a mano
                                        </label>
                                    </div>
                                </div>
                            )}

                            {/* EX-595: con un solo datáfono no se pregunta cuál, es ese.
                                EX-619: con varios, el desplegable arranca vacío. Dejarlo apuntando
                                al predeterminado hacía que confirmar sin mirarlo cobrase en él. */}
                            {debeEnrutarADatafono && datafonosDisponibles.length > 1 && (
                                <div className="mv-datafono-select">
                                    <label className="mv-field__label" htmlFor="mv-datafono">DATÁFONO</label>
                                    <select
                                        id="mv-datafono"
                                        value={datafonoParaCobro?.deviceId || ''}
                                        onChange={(e) => setDatafonoSeleccionado(
                                            datafonosDisponibles.find(d => d.deviceId === e.target.value) || null
                                        )}
                                    >
                                        <option value=''>Elige un datáfono</option>
                                        {datafonosDisponibles.map(datafono => (
                                            <option key={datafono.deviceId} value={datafono.deviceId}>
                                                {datafono.nombre || datafono.deviceId}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}

                            {!esVistaSoloLectura && monederoActivo && (
                                <p className="mv-multipago-saldo">
                                    Saldo disponible: {saldoNumerico.toFixed(2)} €
                                </p>
                            )}

                            {esModoCompletarPago && (
                                <p className="mv-multipago-saldo" style={{ color: '#B45309' }}>
                                    Cita parcialmente pagada — pendiente: {importePendiente.toFixed(2)} €
                                </p>
                            )}

                            {/* EX-516: el desglose se muestra siempre que haya filas (creacion y edicion) */}
                            {metodoPago.length > 0 && (
                                <div className="mv-multipago-reparto">
                                    <p className="mv-section-label">Reparte el importe entre los métodos seleccionados</p>
                                    {metodoPago.map(metodo => {
                                        const valor = repartoPagos[metodo._id] ?? 0;
                                        const noEditable = esFilaNoEditable(metodo);
                                        // EX-518: en modo completar pago, el importe del Monedero no se puede
                                        // editar a mano — toggleMetodoMultipago ya lo fija a min(saldo, restante).
                                        // El usuario sigue pudiendo eliminarlo con la X o el botón del grid.
                                        const importeBloqueadoMonedero = esModoCompletarPago && metodo._id === 'Monedero';
                                        const importeNoEditable = noEditable || importeBloqueadoMonedero;
                                        return (
                                            <div key={metodo.ventaId || metodo._id} className={`mv-multipago-row mv-multipago-row--${metodo._id.replace(/\s+/g, '-').toLowerCase()}`}>
                                                <span className="mv-multipago-bullet" aria-hidden="true" />
                                                <span className="mv-multipago-name">{PAYMENT_LABELS[metodo._id] || metodo._id}</span>
                                                <input
                                                    type="text"
                                                    className="mv-multipago-input"
                                                    value={typeof valor === 'number' && Number.isFinite(valor) ? valor.toFixed(2) : (valor ?? '')}
                                                    onChange={(e) => handleImporteRepartoChange(metodo._id, e.target.value)}
                                                    readOnly={importeNoEditable}
                                                />
                                                <span className="mv-multipago-euro">€</span>
                                                {!noEditable && (
                                                    <button
                                                        type="button"
                                                        className="mv-multipago-remove"
                                                        aria-label={`Quitar ${metodo._id}`}
                                                        onClick={() => toggleMetodoMultipago(metodo)}
                                                    >×</button>
                                                )}
                                            </div>
                                        );
                                    })}
                                    <p className={`mv-multipago-suma ${sumaCuadra ? 'mv-multipago-suma--ok' : 'mv-multipago-suma--ko'}`}>
                                        SUMA: {sumaRepartoRedondeada.toFixed(2)} €
                                    </p>
                                    {monederoExcedeSaldo && (
                                        <p className="mv-multipago-error">
                                            El importe asignado al monedero supera el saldo disponible
                                        </p>
                                    )}
                                </div>
                            )}

                            <div className="mv-field">
                                <label className="mv-field__label">FECHA</label>
                                <input
                                    className="mv-field__input"
                                    type="text"
                                    value={fechaCalendar ? fechaCalendar.format('DD/MM/YYYY') : ''}
                                    readOnly
                                />
                            </div>
                            <div className="mv-field">
                                <label className="mv-field__label">HORA</label>
                                <input
                                    className="mv-field__input"
                                    type="text"
                                    value={timeCalendar ? timeCalendar.format('HH:mm') : ''}
                                    readOnly
                                />
                            </div>

                            {/* Barra importe + botón en flujo (scroll con la columna) */}
                            <div className="mv-footer">
                                <div className="mv-footer__importe">
                                    <span className="mv-footer__importe-label">IMPORTE</span>
                                    <div className="mv-footer__amount">
                                        <input
                                            type="text"
                                            value={typeof total === 'number' && Number.isFinite(total) ? Number(total).toFixed(2) : (total ?? '')}
                                            onChange={handleTotalChange}
                                        />
                                        <span className="mv-footer__euro">€</span>
                                    </div>
                                </div>
                                {(ventaCompletada || esVistaSoloLectura) ? (
                                    <>
                                        <button
                                            className="mv-footer__btn"
                                            onClick={async () => {
                                                const clienteNombre = citaActive?.usuario?.nombre || 'el cliente';
                                                const { isConfirmed } = await Swal.fire({
                                                    title: 'Enviar ticket',
                                                    text: `¿Enviar ticket de venta a ${clienteNombre}?`,
                                                    icon: 'question',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Enviar',
                                                    cancelButtonText: 'Cancelar',
                                                });
                                                if (!isConfirmed) return;

                                                const citaIdEnvio = citaIdParaTicket || citaActive?._id;
                                                setEnviandoTicket(true);
                                                const resp = await dispatch(startEnviarTicketVenta(citaIdEnvio));
                                                setEnviandoTicket(false);
                                                if (resp && resp.ok) {
                                                    setTicketEnviado(true);
                                                    if (citaIdEnvio) {
                                                        dispatch(refreshCita(citaIdEnvio, { ...citaActive, ticketEnviado: true }));
                                                    }
                                                    dispatch(openModalBottom({ text: ['Ticket enviado correctamente'], timeOut: 3 }));
                                                } else {
                                                    dispatch(openModalBottom({ text: [resp?.msg || 'Error al enviar el ticket'], timeOut: 3 }));
                                                }
                                            }}
                                            disabled={enviandoTicket}
                                        >
                                            {enviandoTicket ? 'Enviando...' : (ticketEnviado ? 'Reenviar ticket ✓' : 'Enviar ticket')}
                                        </button>
                                        <button
                                            className="mv-footer__btn"
                                            onClick={() => {
                                                onClose();
                                                if (citaActive && typeof setActiveModalReserva === 'function') {
                                                    setActiveModalReserva(false);
                                                }
                                            }}
                                            disabled={enviandoTicket}
                                        >
                                            Cerrar
                                        </button>
                                    </>
                                ) : (
                                    <button
                                        className="mv-footer__btn"
                                        onClick={handleSubmit}
                                        disabled={isSubmitting || !botonAnotarHabilitado}
                                    >
                                        {isSubmitting
                                            ? 'Procesando...'
                                            : (esModoMultipago && metodoPago.length > 1 ? 'Anotar venta' : 'Completar pago')}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                    </>
                    )}

                </div>
            </div>

            <ModalEsperaDatafono
                abierto={!!estadoCobroDatafono || !!desenlaceCobroDatafono}
                estado={estadoCobroDatafono?.estado}
                importe={estadoCobroDatafono?.importe}
                desenlace={desenlaceCobroDatafono}
                onCancelar={solicitarCancelacionCobro}
                onCerrar={cerrarTrasDesenlaceDatafono}
            />
        </>
    );
};




























                